<div class="header bg-gradient-danger pb-1 pt-5 pt-md-8">
  <div class="container-fluid">
    <div class="header-body"></div>
  </div>
</div>

<div class="container" style="margin-top: -4.1em">
  <!-- Icons is Used as Admin -->
  <mat-tab-group dynamicHeight [(selectedIndex)]="demo1TabIndex" (selectedTabChange)="onTabClick($event)">
    <mat-tab>
      <ng-template mat-tab-label> 1<br>
        Issue Seller<br>Entry
      </ng-template>
      <mat-card class="card">
        <form [formGroup]="issuesellerentryForm">

          <div class="form-row">
            <!-- <mat-form-field class="example-full-width" style="width: 40%; margin-left: 5%; margin-top: 2%">
              <mat-label>Issue Seller Name:</mat-label>
              <input #myInput matInput formControlName="issuesellername"
                [matAutocomplete]="issuesellername" />
              <mat-autocomplete #issuesellername="matAutocomplete">
                <mat-option (onSelectionChange)="selected_name1($event, option)"
                  *ngFor="let option of issue_seller_name " [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field> -->

            <mat-form-field class="example-full-width" style="width: 40%; margin-left: 5%; margin-top: 2%">
              <mat-label>Issue Seller Name:</mat-label>
              <input #myInput matInput formControlName="issuesellername" [matAutocomplete]="issuesellername" />
              <mat-autocomplete #issuesellername="matAutocomplete">
                <mat-option (onSelectionChange)="selected_namebooking($event, option)"
                  *ngFor="let option of filteredOptions | async" [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <div style="display: flex; justify-content: flex-end; width: 100%;">
              <td style="white-space: nowrap; width: 75px;">
                <!-- <button class="btn-sm btn-outline-info" type="button" style="margin-right: 5px;">
                  <i class="fas fa-edit"></i>
                </button>
                <button class="btn-sm btn-outline-danger" type="button">
                  <i class="fas fa-trash"></i>
                </button> -->
              </td>
            </div>
            <!-- <span style="margin-left: 2%; margin-top: 3%; font-size: large; font-weight: bold;">OR</span>
            <mat-form-field class="example-full-width" style="width: 40%; margin-left: 5%; margin-top: 2%">
              <mat-label>Mobile No :</mat-label>
              <input matInput formControlName="smobno" [matAutocomplete]="automob" />
              <mat-autocomplete autoActiveFirstOption #automob="matAutocomplete">
                <mat-option (onSelectionChange)="selected_mob_no($event, option)"
                  *ngFor="let option of filteredOptions2 | async" [value]="option['mobile']">
                  {{ option["mobile"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field> -->
            <div style="margin-top: 3%;margin-left: 3%;">
              <!-- <button style="margin-left: 7%" type="button" mat-raised-button color="primary">
                Find
              </button> -->
            </div>
          </div>

          <div class="tableFixHead1 mb-5">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>
                    <span>All</span>
                    <input type="checkbox" [checked]="selectAll" (change)="toggleSelectAll()">
                  </th>

                  <th>Booking Date</th>
                  <th>Booking/Invoice No.</th>
                  <!-- <th>Invoice No</th> -->
                  <th>Seller Name</th>
                  <th>Issue Name</th>
                  <th>Issue Date</th>
                  <th>Copies</th>
                  <th>Amount</th>
                  <th>Total Amount</th>
                  <th>Representative Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of issueBookingSellerList; let i = index">
                  <td>
                    <input type="checkbox" [checked]="selectedItems.includes(item)" (change)="toggleSelection(item)">
                  </td>

                  <td>{{ item["booking_date"] | date: "dd-MM-yyyy" }}</td>

                  <td>
                    <span *ngIf="item.is_invoice_created !== 'A'">{{ item["booking_number"] }}</span>
                    <span *ngIf="item.is_invoice_created === 'A'">{{ item["invoice_no"] }}</span>
                  </td>

                  <td>{{ item["issue_seller_id"] }}</td>
                  <td>{{ item["issue_category_id"] }}</td>

                  <!-- ✅ Displaying two dates per line -->
                  <td>
                    <ng-container *ngIf="item['issue_date_list']">
                      <ng-container *ngFor="let pair of splitDates(item['issue_date_list'])">
                        {{ pair }}<br />
                      </ng-container>
                    </ng-container>
                  </td>

                  <td>{{ item["issue_copies"] }}</td>
                  <td>{{ item["issue_seller_price"] }}</td>
                  <td>{{ item["total_amount"] }}</td>
                  <td>{{ item["representative_id"] }}</td>

                  <td style="white-space: nowrap; width: 75px;">
                    <button class="btn-sm btn-outline-info" type="button" (click)="getIssueSellerBookingById(item)"
                      style="margin-right: 5px;">
                      <i class="fas fa-edit"></i>
                    </button>
                    <button class="btn-sm btn-outline-danger" type="button"
                      (click)="deleteRecordIssueSellerBooking(item)">
                      <i class="fas fa-trash"></i>
                    </button>

                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="form-row" style="
    display: flex;
    align-items: center;
    justify-content: center; /* Centers the heading text */
    position: relative;
    background-color: #8bbdbd;
    margin-bottom: 2%;
    margin-top: 2%;
    padding: 10px 20px;
    text-align: center;
    width: 100%;
">

            <h2 style="color: black; margin: 0;padding: 5px;">
              Issue Seller Personal Details
            </h2>

            <!-- Font Awesome Arrow Icon -->


            <i class="fas fa-arrow-down" *ngIf="!showFields" style="
            font-size: 24px;
            color: black;
            position: absolute;
            right: 20px;" (click)="toggleFields()"></i>

            <i class="fas fa-arrow-up" *ngIf="showFields" style="
            font-size: 24px;
            color: black;
            position: absolute;
            right: 20px;" (click)="toggleFields()"></i>

          </div>
          <ng-container *ngIf="showFields" style="margin-left: 2%">
            <div class="form-row ">
              <mat-form-field appearance="outline" style="margin-left: 7%; margin-top: 10px; width: 25%">
                <mat-label>Issue Seller Name :</mat-label>
                <input matInput formControlName="issuesellername" [matAutocomplete]="auto" required />
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                  <mat-option (onSelectionChange)="selected_name(option)" *ngFor="let option of filteredOptions | async"
                    [value]="option['name']">
                    {{ option["name"] }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <mat-form-field appearance="outline" style="margin-left: 7%; margin-top: 10px; width: 25%">
                <mat-label>E-Issue Seller Name : </mat-label>
                <input (change)="validateEmail($event)" type="text" matInput formControlName="englishIssueSellerName"
                  placeholder="" />
                <!-- <span matSuffix style="color: gray"><mat-icon> English Issue Seller Name </mat-icon></span> -->
                <!-- <mat-error *ngIf="validemail">
                Please enter a valid email address
              </mat-error>
              <mat-error *ngIf="validemail">
                Email is <strong>required</strong>
              </mat-error> -->
              </mat-form-field>
              <mat-form-field appearance="outline" style="margin-left: 7%; margin-top: 10px; width: 25%">
                <mat-label>Mobile No :</mat-label>
                <input matInput formControlName="mnumber" [matAutocomplete]="automno" />
                <mat-autocomplete autoActiveFirstOption #automno="matAutocomplete">
                  <mat-option (onSelectionChange)="selected_name(option)"
                    *ngFor="let option of filteredOptions1 | async" [value]="option['mob_no']">
                    {{ option["mob_no"] }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field appearance="outline" style="margin-left: 7%; margin-top: 10px; width: 25%">
                <mat-label>Address :</mat-label>
                <textarea matInput placeholder="Address" formControlName="address1"></textarea>
              </mat-form-field>

              <mat-form-field appearance="outline" style="margin-left: 7%; margin-top: 10px; width: 25%">
                <mat-label>Pincode</mat-label>
                <input (change)="getPincode($event)" matInput #postalCode maxlength="6" placeholder=""
                  formControlName="pincode" />
                <mat-hint align="end">{{ postalCode.value.length }} / 6</mat-hint>
              </mat-form-field>

            </div>
            <div class="form-row">


              <!-- <mat-form-field style="width: 27%; margin-left: 15px; margin-top: 10px" appearance="outline">
                <mat-label>Country</mat-label>
                <mat-select (selectionChange)="getCountry($event)" formControlName="country" required>
                  <mat-option *ngFor="let c of countries1" value="{{ c['name'] }}">{{ c["name"] }}</mat-option>
                </mat-select>
              </mat-form-field> -->

              <mat-form-field appearance="outline" style="margin-left: 7%; margin-top: 10px; width: 25%">
                <mat-label>Country</mat-label>
                <mat-select (selectionChange)="getCountry($event)" formControlName="country">
                  <mat-option *ngFor="let c of countries" value="{{ c['country_name'] }}">{{ c["country_name"] }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" style="margin-left: 7%; margin-top: 10px; width: 25%">
                <mat-label>State</mat-label>
                <mat-select (selectionChange)="getState($event)" formControlName="state">
                  <mat-option *ngFor="let c of states" value="{{ c['state_name'] }}">{{ c["state_name"] }}
                  </mat-option>
                </mat-select>
                <span>{{ selectedState }}</span>
              </mat-form-field>

              <mat-form-field appearance="outline" style="margin-left: 7%; margin-top: 10px; width: 25%">
                <mat-label>District</mat-label>
                <mat-select (selectionChange)="getDistricts($event)" formControlName="district">
                  <mat-option *ngFor="let c of cities" value="{{ c['district_name'] }}">
                    {{ c["district_name"] }}
                  </mat-option>
                </mat-select>
                <span>{{ selectedCity }}</span>
              </mat-form-field>
            </div>

            <div class="form-row">


              <mat-form-field appearance="outline" style="margin-left: 7%; margin-top: 10px; width: 25%">
                <mat-label>Taluka</mat-label>
                <mat-select formControlName="taluka">
                  <mat-option *ngFor="let c of talukas" value="{{ c['taluka_name'] }}">{{ c["taluka_name"]
                    }}</mat-option>
                </mat-select>
                <span>{{ selectedTaluka }}</span>
              </mat-form-field>
              <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%; margin-top: 10px;"
                [style.color]="validmobile ? null : 'red'" class="example-full-width">
                <mat-label>Mobile</mat-label>
                <span matPrefix style="color: gray">+91 &nbsp;</span>
                <input type="tel" #mobiles (change)="validateMobile($event)" maxlength="10" formControlName="mnumber"
                  matInput />
                <span matSuffix style="color: gray"><mat-icon> call</mat-icon></span>
                <mat-hint align="end">{{ mobiles.value.length }} / 10</mat-hint>
                <!-- <mat-error *ngIf="validmobile">
                  Please enter a valid mobile no.
                </mat-error>
                <mat-error *ngIf="validmobile">
                  Mobile no. is <strong>required</strong>
                </mat-error> -->
              </mat-form-field>
              <mat-form-field class="example-full-width" style="width: 25%; margin-left: 7%; margin-top: 10px;"
                [style.color]="validemail ? null : 'red'" appearance="outline">
                <mat-label>Email</mat-label>
                <input (change)="validateEmail($event)" type="email" matInput formControlName="email"
                  placeholder="Ex. pat@example.com" />
                <span matSuffix style="color: gray"><mat-icon> email</mat-icon></span>
                <!-- <mat-error *ngIf="validemail">
                  Please enter a valid email address
                </mat-error>
                <mat-error *ngIf="validemail">
                  Email is <strong>required</strong>
                </mat-error> -->
              </mat-form-field>
            </div>

            <div class="form-row">

            </div>
            <div class="form-row">
              <mat-form-field class="example-full-width" style="margin-left: 7%; margin-top: 10px; width: 25%"
                appearance="outline">
                <mat-label>Landline No.</mat-label>
                <input type="text" #land maxlength="12" formControlName="landline_no" matInput />
                <mat-hint align="end">{{ land.value.length }} / 12</mat-hint>
              </mat-form-field>


              <!-- <label style="margin-left: 10px; margin-top: 10px"
                >Date of Birth :
              </label> -->
              <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 25%" appearance="outline">
                <mat-label>Date of Birth</mat-label>
                <input formControlName="dob" matInput [matDatepicker]="datepicke" (dateChange)="validatedob($event)" />
                <mat-datepicker-toggle matSuffix [for]="datepicke"></mat-datepicker-toggle>
                <mat-datepicker #datepicke> </mat-datepicker>
                <mat-error *ngIf="validdob"> Please enter a valid DOB </mat-error>
                <!-- <mat-error *ngIf="validdob">
                  DOB is <strong>required</strong>
                </mat-error> -->
              </mat-form-field>
              <mat-form-field class="example-full-width" style="width: 25%; margin-left: 7%; margin-top: 10px"
                [style.color]="validemail ? null : 'red'" appearance="outline">
                <mat-label>E-Districts : </mat-label>
                <input (change)="validateEmail($event)" type="text" matInput formControlName="edistricts"
                  placeholder="" />

              </mat-form-field>
            </div>
            <div class="form-row">


              <mat-form-field style="margin-left: 7%; width: 40%; margin-top: 10px" class="example-full-width"
                appearance="outline">
                <mat-label>Gst No.</mat-label>
                <input matInput maxlength="15" #gst type="text" formControlName="gstno" />
                <mat-hint align="end">{{ gst.value.length }} / 15</mat-hint>
              </mat-form-field>
              <mat-form-field style="margin-left: 7%; width: 25%; margin-top: 10px" class="example-full-width"
                appearance="outline">
                <mat-label>PAN No.</mat-label>
                <input matInput maxlength="10" #pan type="text" formControlName="panno" />
                <mat-hint align="end">{{ pan.value.length }} / 10</mat-hint>
              </mat-form-field>

              <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 25%" class="example-full-width"
                appearance="outline">
                <mat-label>Deposit Amount &#8377;:</mat-label>
                <input type="number" formControlName="depositamt" matInput />
              </mat-form-field>

              <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 25%" class="example-full-width"
                appearance="outline">
                <mat-label>Opening Balance &#8377;:</mat-label>
                <input type="number" formControlName="opening_bal" matInput />
              </mat-form-field>
            </div>

            <!-- <div class="form-group">
              <button style="margin-left: 125px; width: 70%; margin-top: 10px" type="submit"
                [disabled]="issuesellerentryForm.invalid" mat-raised-button color="primary">
                Add Issue Seller Entry
              </button>
            </div> -->

            <div class="form-group">
              <!-- Add Button -->
              <button *ngIf="!isExistingSeller" style="margin-left: 125px; width: 70%; margin-top: 10px" type="button"
                (click)="saveOrUpdateIssueSellerEntry()" [disabled]="issuesellerentryForm.invalid" mat-raised-button
                color="primary">
                Add Issue Seller Entry
              </button>

              <!-- Update Button -->
              <button *ngIf="isExistingSeller" style="margin-left: 125px; width: 70%; margin-top: 10px" type="button"
                (click)="saveOrUpdateIssueSellerEntry()" [disabled]="issuesellerentryForm.invalid" mat-raised-button
                color="primary">
                Update Issue Seller Entry
              </button>
            </div>
            <!-- <div class="form-group">
              <button
                style="margin-left: 125px; width: 70%; margin-top: 10px"
                type="button"
                (click)="saveOrUpdateIssueSellerEntry()"
                [disabled]="issuesellerentryForm.invalid"
                mat-raised-button
                color="primary"
              >
                Update Issue Seller Entry
              </button>
            </div> -->

          </ng-container>

          <!-- <div class="form-row">
            <mat-radio-group aria-label="Select an option" style="margin-left: 7%" formControlName="option"
              (change)="select($event)">
              <mat-radio-button value="agent">Agent</mat-radio-button>
              <mat-radio-button value="representative" style="margin-left: 20px">Representative</mat-radio-button>
            </mat-radio-group>
          </div> -->

        </form>
        <!-- *ngIf="option" -->
        <!-- (ngSubmit)="saveIssueSellerBookingDetails()" -->
        <form [formGroup]="issueForm">

          <div class="form-row" style="
             justify-content: center;
          background-color: #8bbdbd;
          margin-bottom: 2%;
          margin-top: 2%;
            ">
            <h2 style="text-align: center; margin-top: 10px; color: black">
              Issue Seller Booking
            </h2>
          </div>
          <div>
            <div class="form-row">
              <mat-form-field appearance="outline" style="margin-left: 7%; margin-top: 10px; width: 25%">
                <mat-label>Booking Date</mat-label>
                <input matInput [matDatepicker]="bdpicker" formControlName="bookingDate" [min]="financialYearMin"
                  [max]="financialYearMax" (dateChange)="bookingdateChange($event)" />
                <mat-datepicker-toggle matSuffix [for]="bdpicker"></mat-datepicker-toggle>
                <mat-datepicker #bdpicker></mat-datepicker>

                <mat-error *ngIf="issueForm.get('bookingDate')?.hasError('invalidDate')">
                  Please select a valid date.
                </mat-error>
              </mat-form-field>


              <mat-form-field style="margin-left: 25px; width: 25%;margin-top: 10px">
                <mat-label>Booking No :</mat-label>
                <input type="text" formControlName="bookingNumber" matInput readonly />
              </mat-form-field>
              <mat-form-field class="example-full-width" style="margin-left: 25px; width: 25%;margin-top: 10px">
                <mat-label>Issue Seller Name</mat-label>
                <input #myInput matInput formControlName="issueSellerId" [matAutocomplete]="issueSellerId" />
                <mat-autocomplete #issueSellerId="matAutocomplete">
                  <mat-option (onSelectionChange)="selected_name1($event, option)"
                    *ngFor="let option of filteredOptions | async" [value]="option['name']">
                    {{ option["name"] }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <!-- <div class="form-row"> -->




            <!-- <mat-form-field class="example-full-width" style="width: 40%; margin-left: 7%; margin-top: 2%">
                <mat-label>Office Representative:</mat-label>
                <input #myInput matInput formControlName="officeRepresentativeId"
                  [matAutocomplete]="officeRepresentativeId" />
                <mat-autocomplete #officeRepresentativeId="matAutocomplete">
                  <mat-option *ngFor="let option of offfilteroption22 | async"
                    (onSelectionChange)="selected_off_rep_name($event, option)"
                    [value]="option['office_representative']">
                    {{ option["office_representative"] }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field> -->

            <!-- </div> -->

            <div class="form-row" style="margin-top: 2%">
              <mat-form-field class="example-full-width" style="width: 40%; margin-left: 7%; margin-top: 2%">
                <mat-label>Representative Name:</mat-label>
                <input #myInput matInput formControlName="representativeId" [matAutocomplete]="representativeId" />
                <mat-autocomplete #representativeId="matAutocomplete">
                  <mat-option *ngFor="let option of offfilteroption | async"
                    (onSelectionChange)="selected_rep_name1($event, option)"
                    [value]="option['issue_seller_representative']">
                    {{ option["issue_seller_representative"] }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <!-- <mat-form-field appearance="outline" class="example-full-width" style="margin-left: 5%; width: 35%"
              [style.color]="validmobile ? null : 'red'">
              <mat-label>Representative Mobile No</mat-label>
              <span matPrefix>+91 &nbsp;</span>
              <input type="tel" #m1 (change)="validateMobile($event)" maxlength="10" formControlName="repmobno1"
                matInput />
              <mat-hint align="end">{{ m1.value.length }} / 10</mat-hint>
              <mat-error *ngIf="validmobile">
                Please enter a valid mobile no.
              </mat-error>
              <mat-error *ngIf="validmobile">
                Mobile no. is <strong>required</strong>
              </mat-error>
            </mat-form-field> -->


              <mat-form-field class="example-full-width" style="width: 40%; margin-left: 7%; margin-top: 2%">
                <mat-label>Office Representative</mat-label>
                <input type="text" matInput formControlName="officeRepresentativeId" />
              </mat-form-field>
            </div>
            <div class="form-row">
              <!-- Issue/Grantha -->
              <!-- Category / Grantha -->
              <mat-form-field appearance="outline" style="margin-left: 7%; margin-top: 10px; width: 25%">
                <mat-label>Issue/Grantha</mat-label>
                <mat-select (selectionChange)="getIssues($event)" formControlName="issueCatregoryId" required>
                  <mat-option *ngFor="let item of advtCategorylist" [value]="item.category">
                    {{ item.category }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Year Filter Input -->
              <mat-form-field appearance="outline" style="margin-left: 7%; margin-top: 10px; width: 20%;">
                <mat-label>Enter Year(s)</mat-label>
                <input matInput (input)="onYearInputChange($event.target.value)" />
              </mat-form-field>

              <!-- Issue Name -->
              <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 25%" appearance="outline">
                <mat-label>Issue Name : </mat-label>
                <mat-select #mySel (selectionChange)="getAdvtDates($event)" formControlName="issueNameId" multiple
                  required>
                  <mat-option value="all" (click)="toggleAllSelection()">All</mat-option>
                  <mat-option *ngFor="let item of filteredIssueDates"
                    [value]="[item['issueDate'], item['issueName'], item['id'], item['price']]">
                    {{ item["issueDate"] | date: "dd-MM-yyyy" }} {{ item["issueName"] }}
                  </mat-option>
                </mat-select>
              </mat-form-field>



              <!-- <mat-form-field appearance="outline" style="margin-left: 20px; margin-top: 10px; width: 25%">
                <mat-label>Issue Date</mat-label>
                <input matInput [matDatepicker]="bdpicker" formControlName="issueSellerDate" />
                <mat-datepicker-toggle matSuffix [for]="bdpicker"></mat-datepicker-toggle>
                <mat-datepicker #bdpicker></mat-datepicker>
              </mat-form-field> -->

              <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 24%" class="example-full-width"
                appearance="outline">
                <mat-label>Issue Rate</mat-label>
                <input matInput type="number" formControlName="issueSellerPrice" />
              </mat-form-field>

              <mat-form-field style="margin-left: 7%; width: 25%; margin-top: 10px" appearance="outline">
                <mat-label>Discount Amount</mat-label>
                <input matInput type="number" formControlName="discount_amt" />
              </mat-form-field>

              <mat-form-field style="margin-left: 7%; width: 25%; margin-top: 10px;" class="example-full-width"
                appearance="outline">
                <mat-label>Amount After Discount</mat-label>
                <input matInput type="number" formControlName="afterdistamt" readonly />
              </mat-form-field>



              <mat-form-field style="margin-left: 7%; width: 25%; margin-top: 10px" class="example-full-width"
                appearance="outline">
                <mat-label>Copies</mat-label>
                <input matInput type="number" formControlName="issueSellerCopies" />
              </mat-form-field>
              <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 25%" class="example-full-width"
                appearance="outline">
                <mat-label>Complementory Copies</mat-label>
                <input matInput type="number" formControlName="complementaryCopies" />
              </mat-form-field>

              <!-- Only Show Discount Amount -->
              <!-- <mat-form-field style="margin-left: 7%; width: 25%; margin-top: 10px" appearance="outline">
                <mat-label>Discount Amount</mat-label>
                <input matInput type="number" formControlName="discount_amt" />
              </mat-form-field>

              <mat-form-field style="margin-left: 7%;width: 25%;margin-top: 10px;" class="example-full-width"
                appearance="outline">
                <mat-label>Amount After Discount</mat-label>
                <input matInput type="number" formControlName="afterdistamt" />
              </mat-form-field> -->
              <button type="button" style="height: 1%; margin-left: 20px; margin-top: 20px" mat-raised-button
                color="warn" (click)="addAdvt()">
                Add
              </button>
            </div>
            <div class="form-row mb-5">

              <!-- Delete Selected Button -->
              <button type="button" class="btn btn-danger mb-2" style="height: 1%; margin-left: 20px; margin-top: 20px"
                mat-raised-button color="warn" (click)="deleteSelected()" [disabled]="!selectedItems1.length"
                style="margin-left: 7%;margin-left: 776px;">
                Delete Selected
              </button>

              <table class="table table-striped text-center"
                style="margin-left: 7%; margin-top: 10px; margin-right: 30px; border: 1px solid black;">
                <thead>
                  <tr>
                    <th>
                      <span>All</span>
                      <input type="checkbox" [checked]="selectAll1" (change)="toggleSelectAll1($event)">
                    </th>
                    <th>Sr.No.</th>
                    <th>Issue Name</th>
                    <th>Issue Dates</th>
                    <th>Price</th>
                    <th>Copies</th>
                    <th>Complementory Copies</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let sub of AdvtDetails; let i = index">
                    <td>
                      <input type="checkbox" [checked]="isSelected(sub)" (change)="toggleItemSelection(sub)">
                    </td>
                    <td>{{ i + 1 }}</td>
                    <td>{{ sub.issue }}</td>
                    <td>{{ sub.issueSellerDate }}</td>
                    <td>{{ sub.issueSellerPrice }}</td>
                    <td>{{ sub.issueSellerCopies }}</td>
                    <td>{{ sub.complementaryCopies }}</td>
                    <td>
                      <button type="button" class="btn btn-danger btn-sm" (click)="deleteAdvt(i)">
                        Remove
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>



            <!-- <div class="form-row">
              <mat-form-field style="margin-left: 7%; width: 60%; margin-top: 10px" class="example-full-width"
                appearance="outline">
                <mat-label>Issue Rate</mat-label>
                <input matInput type="number" formControlName="issuerate" />
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field style="margin-left: 7%; width: 60%; margin-top: 10px" class="example-full-width"
                appearance="outline">
                <mat-label>Issue copies</mat-label>
                <input matInput type="number" formControlName="issuecopies" />
              </mat-form-field>
            </div> -->
            <div class="form-row">
              <mat-form-field style="margin-left: 7%; width: 25%; margin-top: 10px" class="example-full-width"
                appearance="outline">
                <mat-label>Amount &#8377;:</mat-label>
                <input matInput type="number" formControlName="amount" />
              </mat-form-field>
              <!-- <mat-form-field  *ngIf="!discountAmtHideShow" style="margin-left: 20px; width: 20%; margin-top: 10px"
            class="example-full-width"appearance="outline"><mat-label>Discount ₹:</mat-label>
            <input matInput type="number" formControlName="discountAmount" />
          </mat-form-field>  -->

              <mat-form-field style="margin-left: 7%;width: 25%; margin-top: 10px" class="example-full-width"
                appearance="outline">
                <mat-label>Net Amount &#8377;:</mat-label>
                <input matInput type="number" formControlName="netAmount" />
              </mat-form-field>

              <mat-form-field style="margin-left: 7%; width: 25%; margin-top: 10px" class="example-full-width"
                appearance="outline">
                <mat-label>Total Amount &#8377;:</mat-label>
                <input matInput type="number" formControlName="totalAmount" />
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-radio-group aria-label="Select an option" style="margin-left: 7%"
                formControlName="issueSellerGstType" (change)="gstCalculation()">
                <mat-radio-button value="NO_GST">No Gst</mat-radio-button>
                <mat-radio-button value="INCLUDING">Gst Including</mat-radio-button>
                <mat-radio-button value="EXCLUDING">Gst Excluding</mat-radio-button>
              </mat-radio-group>

            </div>
            <div class="form-row" *ngIf="issueForm.get('issueSellerGstType')?.value != 'NO_GST'">
              <mat-form-field style="margin-left: 7%; width: 20%; margin-top: 10px" class="example-full-width"
                appearance="outline">
                <mat-label>GST(&#37;) </mat-label>
                <input matInput type="number" formControlName="gstPercentage" (input)="gstCalculation()" />
              </mat-form-field>
              <mat-form-field style="margin-left: 7%; width: 20%; margin-top: 10px" class="example-full-width"
                appearance="outline">
                <mat-label>GST &#8377;:</mat-label>
                <input matInput type="number" formControlName="gstAmount" />
              </mat-form-field>
              <mat-form-field style="margin-left: 7%; width: 20%; margin-top: 10px" class="example-full-width"
                appearance="outline">
                <mat-label>Without GST &#8377;:</mat-label>
                <input matInput type="number" formControlName="withoutGstAmount" />
              </mat-form-field>
              <mat-form-field style="margin-left: 7%; width: 20%; margin-top: 10px" class="example-full-width"
                appearance="outline">
                <mat-label>With GST &#8377;:</mat-label>
                <input matInput type="number" formControlName="withGstAmount" />
              </mat-form-field>
            </div>
            <div class="form-row">
              <!-- (selectionChange)="SelectRepresentative($event)" -->


              <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%;margin-top: 10px">
                <mat-label>Delivery Mode</mat-label> <mat-select #mySel13 formControlName="deliveryModeId" multiple
                  (selectionChange)="onDeliveryModeChange1($event.value)"> <!-- Select All option --> <mat-option
                    value="all" (click)="toggleAllSelectionpl()"> All </mat-option> <!-- Individual delivery modes -->
                  <mat-option *ngFor="let rep of delivery_mode" [value]="rep.delivery_mode"> {{ rep.delivery_mode }}
                  </mat-option>
                </mat-select> <!-- Reset button --> <button *ngIf="selectedModes?.length" matSuffix mat-icon-button
                  aria-label="Clear" (click)="resetDeliveryModes1()"> <mat-icon>close</mat-icon> </button>
              </mat-form-field>

              <!-- Distribution Representative -->
              <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%;margin-top: 10px">
                <mat-label>Distribution Representative</mat-label>
                <input matInput formControlName="distributionRepresentativeId" [matAutocomplete]="autoDistpl1" />
                <mat-autocomplete autoActiveFirstOption #autoDistpl1="matAutocomplete">
                  <mat-option (onSelectionChange)="distribution($event, option)"
                    *ngFor="let option of filteredOptions6 | async" [value]="option['name']">
                    {{ option["name"] }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <!-- Distribution Mode -->
              <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%;margin-top: 10px">
                <mat-label>Distribution Mode</mat-label>

                <mat-select #mySel15 formControlName="distributionMode" multiple
                  (selectionChange)="onDeliveryModeChange3($event.value)">

                  <!-- Select All option -->
                  <mat-option value="all" (click)="toggleAllSelectiondpl($event)">All</mat-option>

                  <!-- Individual options -->
                  <mat-option *ngFor="let option of filteredOptions7 | async" [value]="option.name">
                    {{ option.name }}
                  </mat-option>
                </mat-select>

                <!-- Reset button -->
                <!-- <button *ngIf="selectedModes2?.length" matSuffix mat-icon-button aria-label="Clear"
              (click)="resetDistributionModeModes1()">
              <mat-icon>close</mat-icon>
            </button> -->
                <button *ngIf="issueForm.get('distributionMode')?.value" matSuffix mat-icon-button
                  (click)="resetDistributionModeModes1()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>


              <!-- Sub Distribution Mode -->
              <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%;margin-top: 10px">
                <mat-label>Sub Distribution Mode</mat-label>
                <mat-select #mySel16 formControlName="deliverySubModeId" multiple>

                  <!-- Select All option -->
                  <mat-option (click)="toggleAllSelectionspl($event)">All</mat-option>

                  <!-- Individual options -->
                  <mat-option *ngFor="let option of filteredOptions28 | async" [value]="option.name">
                    {{ option.name }}
                  </mat-option>
                </mat-select>

                <!-- Reset button -->
                <button *ngIf="selectedModes?.length" matSuffix mat-icon-button aria-label="Clear"
                  (click)="resetsubDeliveryModes1()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>


              <mat-form-field style="margin-left: 7%; width: 50%; margin-top: 10px" class="example-full-width"
                appearance="outline">
                <mat-label>Remarks</mat-label>
                <input matInput type="text" formControlName="issueRemark" />
              </mat-form-field>
            </div>


          </div>
          <div class="form-group">
            <button style="margin-left: 125px; width: 70%; margin-top: 10px" type="button" *ngIf="id==null"
              [disabled]="issueForm.invalid" mat-raised-button color="primary"
              (click)="saveIssueSellerBookingDetails()">
              Add Issue Booking Details
            </button>
            <!-- [disabled]="issueForm.invalid" -->
            <button style="margin-left: 125px; width: 70%; margin-top: 10px" type="button" *ngIf="id!=null"
              [disabled]="issueForm.invalid" mat-raised-button color="primary" (click)="updateIssueRegistration()">
              Update Issue Booking Details
            </button>
          </div>
        </form>
      </mat-card>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label> 2<br>
        Issue Seller<br>Registration Report
      </ng-template>
      <form class="form" [formGroup]="RegistrationreportRange">
        <mat-form-field style="margin-top: 5%; margin-left: 3%;" class="col-4">
          <mat-label>Issue Seller Received Date</mat-label>

          <mat-date-range-input [rangePicker]="picker2" [min]="financialYearMin" [max]="financialYearMax"
            [formGroup]="RegistrationreportRange">
            <input matStartDate formControlName="start" placeholder="Start date" />
            <input matEndDate formControlName="end" placeholder="End date"
              (dateChange)="getChangedDateRegistrationReport()" />
          </mat-date-range-input>

          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-date-range-picker #picker2></mat-date-range-picker>

          <!-- Date errors -->
          <mat-error *ngIf="RegistrationreportRange.get('start')?.hasError('required')">
            Start date is required
          </mat-error>
          <mat-error *ngIf="RegistrationreportRange.get('end')?.hasError('required')">
            End date is required
          </mat-error>

          <mat-error *ngIf="RegistrationreportRange.hasError('financialYearInvalid')">
            Both dates must be within the current financial year
          </mat-error>
        </mat-form-field>


        <span style="margin-left: 3%; font-size: large; font-weight: bold">
          OR
        </span>

        <mat-form-field style="margin-left: 3%" class="col-4">
          <mat-label>Representative : </mat-label>
          <mat-select #mySelr2 (selectionChange)="getRepName1($event)" formControlName="repname" multiple>
            <mat-option value="ALL" (click)="toggleAllSelectionc1()">All</mat-option>
            <mat-option *ngFor="let item of contractRepName" value="{{  item['name'] }}">{{ item["name"]
              }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <span style="margin-left: 3%; font-size: large; font-weight: bold">
          OR
        </span>

        <mat-form-field style="margin-left: 3%" class="col-4">
          <mat-label>Office Representative : </mat-label>
          <mat-select #mySelr1 (selectionChange)="getOfficeRep($event)" formControlName="offrepname" multiple>
            <mat-option value="ALL" (click)="toggleAllSelectionc2()">All</mat-option>
            <mat-option *ngFor="let item of contractOffRepName" value="{{  item['name'] }}">{{
              item["name"]
              }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <span style="margin-left: 3%; font-size: large; font-weight: bold">
          OR
        </span>

        <mat-form-field style="margin-left: 3%" class="col-4">
          <mat-label>Issue/grantha : </mat-label>
          <mat-select (selectionChange)="getIssues($event)" formControlName="issuename" required>
            <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
              {{ item.category }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <span style="margin-left: 3%; font-size: large; font-weight: bold">
          OR
        </span>

        <mat-form-field style="margin-left: 3%" class="col-4">
          <mat-label>Issue Dates : </mat-label>
          <mat-select #mySel2 (selectionChange)="getAdvtDates($event)" formControlName="issuedate" multiple required>
            <mat-option value="ALL" (click)="toggleAllSelection2()">All</mat-option>
            <!-- <mat-option *ngFor="let item of getMagIssueDatesandNames" value="{{
                                [
                                  item['issueDate'] | date : 'dd/MM/yyyy',
                                  item['issueName']'
                                ]
                              }}">{{ item["issueDate"] | date :
            "dd/MM/yyyy" }}
            {{ item["issueName"] }} 
          </mat-option> -->
            <mat-option *ngFor="let item of getMagIssueDatesandNames"
              value="{{ [item['issueDate'], item['issueName'], item['id']] }}">{{ item["issueDate"] | date
              :
              "dd/MM/yyyy" }}
              {{ item["issueName"] }}

            </mat-option>
          </mat-select>
        </mat-form-field>

        <span style="margin-left: 3%; font-size: large; font-weight: bold">
          OR
        </span>

        <mat-form-field style="margin-left: 3%" class="col-4">
          <mat-label>Select Type Of Report</mat-label>
          <mat-select (selectionChange)="checkReportType($event)">
            <mat-option value="InDetail"> In Detail </mat-option>
            <mat-option value="Briefly"> Briefly </mat-option>
            <mat-option value="Represantative Indetails">Indetails-Represantative</mat-option>
            <mat-option value="Represantative Briefly">Briefly-Represantative </mat-option>
            <mat-option value="Represantative very Briefly">Very Briefly Represantative</mat-option>
            <mat-option value="Off_Represantative Indetails">Indetails Off Represantative</mat-option>
            <mat-option value="Off_Represantative Briefly">Briefly Off Represantative</mat-option>
            <mat-option value="Off_Represantative very Briefly">Very Briefly Off Represantative</mat-option>
            <mat-option value="Datewise Indetails">Indetails datewise</mat-option>
            <mat-option value="Datewise Briefly">Briefly-Datewise</mat-option>
            <mat-option value="datewise_very_briefly">Very Briefly Datewise</mat-option>
          </mat-select>
        </mat-form-field>

      </form>
      <button style="margin-left: 3%" (click)="getAdvtRegistrationReport($event)" mat-raised-button color="primary">
        Find
      </button>
      <!-- <mat-card *ngIf="showindetail">
        <div class="tableFixHead" id="excel-table">
          <button type="button" mat-raised-button matTooltip="Download Execelsheet" class="btn btn-danger"
            (click)="exportexcel('Registration Report')" style="float: right">
            Export
          </button>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th colspan="3">Vivek Saptahik</th>
                <th colspan="5">Advt. Registreation Report</th>
                <th colspan="2">In Detail</th>
                <th colspan="2"></th>
                <th colspan="3"></th>
                <th colspan="3">Date :</th>
              </tr>
              <tr>
                <th colspan="3">Date. From :</th>
                <th colspan="2">To :</th>
                <th colspan="3">Issue/Grantha Categary :</th>
                <th colspan="2">Issue Date :</th>
                <th colspan="5">Issue Name :</th>
                <th colspan="3">Page No</th>
              </tr>
              <tr>
                <th>Issue Sr. No</th>
                <th>Booking Date</th>
                <th>Booking No</th>
                <th>Advertiser Name</th>
                <th>Customer Name</th>
                <th>Representative Name</th>
                <th>Mobile No</th>
                <th>Office Represantative Name</th>
                <th>RO Number</th>
                <th>Instruction</th>
                <th>Advt.Size</th>
                <th>Advt Amount Rs</th>
                <th>Net Amount</th>
                <th>GST 5%</th>
                <th>Total Amount</th>
                <th>Received Amount</th>
                <th>Receipt No. and Date</th>
                <th>Pending Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of filteredinDetailsRegReport; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item["booking_date"] | date : "dd-MM-yyy" }}</td>
                <td>{{ item["booking_no"] }}</td>
                <td>{{ item["advt_name"] }}</td>
                <td>{{ item["cust_name"] }}</td>
                <td>{{ item["rep_name"] }}</td>
                <td>{{ item["rep_mob_no"] }}</td>
                <td>{{ item["off_rep_name"] }}</td>
                <td>{{ item["ro_no"] }}</td>
                <td>{{ item["instruction"] }}</td>
                <td>{{ item["advtsize"] }}</td>
                <td>{{ item["advt_amt"] }}</td>
                <td>{{ item["total_amount"] }}</td>
                <td>{{ toInt(item["sgst"]) + toInt(item["cgst"]) }}</td>
                <td>{{ item["amount"] }}</td>
                <td>{{ item["part_pymt_amt"] }}</td>
                <td>
                  {{ item["rep_rcpt_no"] }}<br />
                  {{ item["rcpt_date"] | date : "dd-MM-yyy" }}
                </td>
                <td>{{ item["part_pymt_remaning_amt"] }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="2">Total</td>
                <td colspan="2">
                  Total No of Advt :
                  {{ this.inDetailsRegReportTotal.total_advt }}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{ this.inDetailsRegReportTotal.advt_total }}</td>
                <td>{{ this.inDetailsRegReportTotal.net_amt }}</td>
                <td>{{ this.inDetailsRegReportTotal.gst }}</td>
                <td>{{ this.inDetailsRegReportTotal.total_amt }}</td>
                <td>{{ this.inDetailsRegReportTotal.rcvd_amt }}</td>
                <td></td>
                <td>{{ this.inDetailsRegReportTotal.pndg_amt }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </mat-card> -->

    </mat-tab>
    <mat-tab>
  <ng-template mat-tab-label>
    
      3<br>
      Issue Seller<br>
      Invoice
    
  </ng-template>
    
      <mat-card class="card">
        <form [formGroup]="issueSellerbillForm">
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 40%" appearance="outline">
              <mat-label>Issue/grantha : </mat-label>
              <mat-select (selectionChange)="getIssuesForInvoice($event)" required formControlName="issuename">
                <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
                  {{ item.category }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field style="margin-left: 20px; margin-top: 10px; width: 40%" appearance="outline">
              <mat-label>Issue Date : </mat-label>
              <mat-select #mySel (selectionChange)="getIssueInvoiceDates($event)" formControlName="issuedate" multiple
                required>
                <mat-option value="all" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of getMagIssueDatesandNames"
                  value="{{ [item['issueDate'], item['issueName']] }}">{{ item["issueDate"] | date: "dd-MM-yyy" }}
                  {{ item["issueName"] }}
                </mat-option>
                <!--  -->
              </mat-select>
            </mat-form-field>

          </div>
          <div class="form-row">



            <!-- <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 40%" appearance="outline">
              <mat-label>Seller Name : </mat-label>
              <mat-select #isn (selectionChange)="getISN($event)" multiple required formControlName="issue_seller_name">
                <mat-option value="all" (click)="toggleAllSelectionISN()">All</mat-option>
                <mat-option *ngFor="let option of issue_seller_name" [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>  -->

            <!-- <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 40%" appearance="outline">
              <mat-label>Seller Name :</mat-label>
              <input #myInput matInput formControlName="issue_seller_name" [matAutocomplete]="issue_seller_name" />
              <mat-autocomplete #issue_seller_name="matAutocomplete">
                <mat-option *ngFor="let option of issueSellerNames | async"
                  (onSelectionChange)="selected_issue_seller_name($event, option)"
                  [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field> -->

            <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 40%" appearance="outline">
              <mat-label>Seller Name</mat-label>

              <mat-select [formControl]="selectedItems2" multiple (selectionChange)="updateAllSelectedState()">

                <!-- All option -->
                <mat-option (click)="selectAllOptions($event)">All</mat-option>

                <!-- Search input inside mat-select -->
                <mat-option disabled>
                  <input placeholder="Search Issue Seller Name here...!" [formControl]="searchControl2"
                    (click)="$event.stopPropagation()"
                    style="width: 100%; padding: 6px; font-size: 16px; border: none; background-color: transparent;" />
                </mat-option>

                <!-- Filtered seller options -->
                <mat-option *ngFor="let option of filteredOptions2" [value]="option">
                  {{ option }}
                </mat-option>

              </mat-select>
            </mat-form-field>


            <h3 style="margin-left: 20px; margin-top: 10px; width: 25%">Select receipt is New/Delete</h3>
            <mat-button-toggle-group formControlName="newordeleted" (change)="newordelinvoice($event)" name="fontStyle"
              aria-label="Font Style" style="height: 50px;margin-top: 10px;">
              <mat-button-toggle value="new">New</mat-button-toggle>
              <mat-button-toggle value="deleted">Deleted</mat-button-toggle>
            </mat-button-toggle-group>

          </div>
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 40%" class="example-full-width"
              appearance="outline">
              <mat-label>Date</mat-label>
              <input matInput [matDatepicker]="picker8" formControlName="date" [min]="financialYearMin"
                [max]="financialYearMax" (dateChange)="advtInvoiceDate($event)" required />
              <mat-datepicker-toggle matSuffix [for]="picker8"></mat-datepicker-toggle>
              <mat-datepicker #picker8 [dateFilter]="dateFilter"></mat-datepicker>

              <!-- Error message for financial year validator -->
              <mat-error *ngIf="issueSellerbillForm.get('date')?.hasError('invalidDate')">

                Selected date is not within the current financial year
              </mat-error>
            </mat-form-field>

            <mat-form-field *ngIf="!deleterec" style="margin-left: 20px; margin-top: 10px; width: 40%"
              class="example-full-width" appearance="outline">
              <mat-label>Bill No :</mat-label>
              <input type="text" formControlName="billno" matInput required readonly />
            </mat-form-field>
            <mat-form-field *ngIf="deleterec" style="margin-left: 20px; margin-top: 10px; width: 40%"
              class="example-full-width" appearance="outline">
              <mat-label>Bill No (deleted) :</mat-label>
              <mat-select formControlName="billno" required>
                <mat-option *ngFor="let bill of getdeletereciptinvoice" [value]="bill.rcpt_no">
                  {{ bill.rcpt_no }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-group">
            <button style="margin-left: 125px; width: 70%; margin-top: 10px" type="submit"
              [disabled]="issueSellerbillForm.invalid" (click)="openAdvtBill()" mat-raised-button color="primary">
              Add Issue Sale Bill
            </button>
          </div>
        </form>
      </mat-card>

      <mat-card class="card">
        <h2 style="text-align:center">List of Issue Seller Invoice</h2>

        <div>
          <form [formGroup]="issueSellerbillFormsecond">
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Search Date</mat-label>
              <mat-date-range-input [rangePicker]="pickerrAi"[min]="financialYearMin"
                  [max]="financialYearMax">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getChangedDateContractM11()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerrAi"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerrAi></mat-date-range-picker>

              <mat-error *ngIf="contractDetailsForm.controls.start.hasError(
                                  'matStartDateInvalid'
                                )
                              ">Invalid start date
              </mat-error>
              <mat-error *ngIf="contractDetailsForm.controls.end.hasError('matEndDateInvalid')
                              ">Invalid end date
              </mat-error>
            </mat-form-field>
          </form>
        </div>
        <div class="tableFixHead">
          <button [ngStyle]="{'display':allSelectedtable || someComplete() ? 'block' : 'none'}" style="float: right;"
            mat-raised-button class="btn btn-primary" (click)="printAdvtInvoice()">Print
            Invoices</button>
          <table class="table table-striped">
            <thead>
              <tr>
                <th>
                  <mat-checkbox class="example-margin" [checked]="allSelectedtable" color="primary"
                    [indeterminate]="someComplete()" (change)="setAll($event.checked)">
                  </mat-checkbox>
                </th>
                <th>Sr. No.</th>
                <th>Invoice No.</th>
                <th>Invoice Date</th>
                <th>Issue Seller Name</th>
                <th>Action</th>

                <!-- <th>GST.No</th>
                <th>Pan.No</th> -->

                <!-- <th>1 Week</th>
                <th>2 Week</th>
                <th>3 Week</th>
                <th>4 Week </th>
                <th>5 Week </th>
                <th>Pay Amount </th>
                <th>Pre Amount</th>
                <th>Remaining Amount</th>
                <th>Booking.No</th> -->

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of advtInvoiceList; let i=index">
                <td>
                  <mat-checkbox [(ngModel)]="data.is_selected" color="primary" (ngModelChange)="updateAllComplete()">
                  </mat-checkbox>
                </td>
                <td>{{ i+1 }}</td>
                <td>{{ data['invoice_no'] }}</td>
                <td>{{ data['invoice_date'] }}</td>
                <td>{{ data['issue_seller_name'] }}</td>
                <!-- <td>{{ data['gst_no'] }}</td>
                <td>{{ data['pan_no'] }}</td> -->

                <!-- <td>{{ data['first_week_id'] }}</td>
                <td>{{ data['second_week_id'] }}</td>
                <td>{{ data['third_week_id'] }}</td>
                <td>{{ data['fourth_week_id'] }}</td>
                <td>{{ data['fifth_week_id'] }}</td>
                <td>{{ data['pay_amt'] }}</td>
                <td>{{ data['pre_amt'] }}</td>
                <td>{{ data['remaining_amt'] }}</td>
                <td>{{ data['booking_no'] }}</td> -->
                <td>
                  <button mat-icon-button matTooltip="View" class="btn-sm btn-outline-primary"
                    (click)="viewIssueSellerInvoice(data.id)"><mat-icon>visibility</mat-icon></button>

                  <!-- <button mat-icon-button matTooltip="Edit" class="btn-sm btn-outline-danger"
                    (click)="updateIssueSellerInvoice(data)"><mat-icon>edit</mat-icon></button> -->

                  <button mat-icon-button matTooltip="Cancel" class="btn-sm btn-outline-danger"
                    (click)="deleteIssueSellerInvoice(data.id)">
                    <mat-icon>delete</mat-icon>
                  </button>

                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card>

      <!-- <mat-card class="card">
        <h2 style="text-align:center">List without page no</h2>

        <table>
          <thead>
            <tr>
              <th>Sr</th>
              <th>Advt ID</th>
              <th>Name</th>
              <th>Reprensantive Name</th>
              <th>OffReprensantive Name</th>
              <th>Booking Date</th>
              <th>Booking No</th>
              <th>Issue Name</th>
              <th>Issue Date</th>
              <th>Advt Size</th>
              <th>Page</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of PPwithoutnumber; let i = index">
              <td>{{i+1}}</td>
              <td>{{data.advt_count}}</td>
              <td>{{data.DS_ADVTID}}</td>
              <td>{{data.name}}</td>
              <td>{{data.rep_name}}</td>
              <td>{{data.off_rep_name}}</td>
              <td>{{data.booking_date}}</td>
              <td>{{data.booking_no}}</td>
              <td>{{data.DS_ISSUENAME}}</td>
              <td>{{data.DS_ISSUEDATE}}</td>
              <td>{{data.DS_advtsize}}</td>
              <td> <input [(ngModel)]="data.pages_no" style="width: 60px; height: 30px;" type="number" /></td>
              <td><button type="button" class="btn-sm btn-outline-info" matTooltip="Add" (click)="addpageno(data)">
                  <mat-icon>add</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </mat-card> -->
    </mat-tab>

    <mat-tab>

      <ng-template mat-tab-label> 4<br>
        Issue Seller<br>Invoice Register
      </ng-template>
      <mat-card class="card">
        <form [formGroup]="issueinvoiceForm">
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 40%" appearance="outline">
              <mat-label>Select Date</mat-label>

              <mat-date-range-input [rangePicker]="advtInvoiceR" [min]="financialYearMin" [max]="financialYearMax"
                [formGroup]="issueinvoiceForm">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getChangedDateAdvtInvoice()" />
              </mat-date-range-input>

              <mat-datepicker-toggle matSuffix [for]="advtInvoiceR"></mat-datepicker-toggle>
              <mat-date-range-picker #advtInvoiceR></mat-date-range-picker>

              <!-- Required or invalid errors -->
              <mat-error *ngIf="issueinvoiceForm.get('start')?.hasError('required')">
                Start date is required
              </mat-error>
              <mat-error *ngIf="issueinvoiceForm.get('end')?.hasError('required')">
                End date is required
              </mat-error>

              <mat-error *ngIf="issueinvoiceForm.hasError('financialYearInvalid')">
                Both dates must be within the current financial year
              </mat-error>
            </mat-form-field>

            <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 40%" appearance="outline">
              <mat-label>Issue/grantha : </mat-label>
              <mat-select (selectionChange)="getIssues($event)" formControlName="issuename" required>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>

                <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
                  {{ item.category }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 40%" appearance="outline">
              <mat-label>Issue Dates:</mat-label>
              <mat-select (selectionChange)="getAdvtDates($event)" formControlName="issuedate" multiple required>
                <!-- Select All option -->
                <mat-option [value]="'ALL'">All</mat-option>

                <!-- Individual issue dates -->
                <mat-option *ngFor="let item of getMagIssueDatesandNames" [value]="item.issueDate">
                  {{ item.issueDate | date: "dd/MM/yyyy" }} - {{ item.issueName }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 40%" appearance="outline">
              <mat-label>Report Type</mat-label>
              <mat-select (selectionChange)="getAdvtInvoiceReportType($event)">
                <mat-option value="In Detail">In Detail
                </mat-option>
                <mat-option value="Briefly">Briefly
                </mat-option>
                <mat-option value="Monthwise">Monthwise
                </mat-option>
                <mat-option value="rnireport">Issue Seller RNI Report
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- 
          <div class="form-row">
          
          </div> -->

          <div class="form-group">
            <button style="margin-left: 125px; width: 70%; margin-top: 10px" type="submit"
              (click)="openAdvtInvoiceRegister()" mat-raised-button color="primary">
              Search
            </button>
          </div>
        </form>
      </mat-card>
    </mat-tab>


    <!-- <mat-tab label="Issue Sale Challan">
      <mat-card class="card">
        <form [formGroup]="publicationsaleForm" (ngSubmit)="save_publicationsale()">
          <div class="form-row">
       
            <mat-form-field style="margin-left: 40px; margin-top: 10px; width: 40%" appearance="outline">
              <mat-label>Challan Date</mat-label>
              <input matInput [matDatepicker]="picker6" (dateChange)="Generatechallanno()" formControlName="cdate"
                required />
              <mat-datepicker-toggle matSuffix [for]="picker6"></mat-datepicker-toggle>
              <mat-datepicker #picker6></mat-datepicker>
            </mat-form-field>

           40px; margin-top: 10px; width: 40%" appearance="outline">
              <mat-label>Challan No.</mat-label>
              <input type="text" formControlName="challanno" matInput required />
            </mat-form-field>

          </div>
          <div class="form-row">
            <mat-form-field style="margin-left: 40px; margin-top: 10px; width: 40%" appearance="outline">
              <mat-label>Issue/grantha : </mat-label>
              <mat-select (selectionChange)="getIssues($event)" required>
                <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
                  {{ item.category }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field style="margin-left: 40px; margin-top: 10px; width: 40%" appearance="outline">
              <mat-label>Issue Dates : </mat-label>
              <mat-select #mySel (selectionChange)="getAdvtDates($event)" multiple required>
                <mat-option value="all" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of getMagIssueDatesandNames"
                  value="{{ [item['issueDate'], item['issueName'], item['id']] }}">{{ item["issueDate"] | date:
                  "dd-MM-yyy" }}
                  {{ item["issueName"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-row">
          
          </div>
          <mat-form-field style="margin-left: 40px; margin-top: 10px; width: 40%" appearance="outline">
            <mat-label>Delivery Mode</mat-label>
            <mat-select #mySel134 required formControlName="deliveryModeId"
              (selectionChange)="onDeliveryModeChange($event.value)">
              <mat-option *ngFor="let rep of delivery_mode" value="{{ rep['delivery_mode'] }}">{{
                rep["delivery_mode"]
                }}
              </mat-option>
            </mat-select>
          </mat-form-field>



          <mat-form-field style="margin-left: 40px; margin-top: 10px; width: 40%;" appearance="outline">
            <mat-label>Distribution Representative</mat-label>
            <input matInput formControlName="distributionRepresentativeId" [matAutocomplete]="autoRep" />
            <mat-autocomplete autoActiveFirstOption #autoRep="matAutocomplete">
              <mat-option *ngFor="let option of filteredOptions6 | async" [value]="option.name"
                (onSelectionChange)="optionSelected($event, option)">
                {{ option.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field style="margin-left: 40px; margin-top: 10px; width: 40%" appearance="outline">
            <mat-label>Distribution Mode</mat-label>
            <input matInput formControlName="distributionMode" [matAutocomplete]="autoDist1" />

           
            <button *ngIf="issueForm.get('distributionMode')?.value" matSuffix mat-icon-button
              (click)="resetDistributionMode()">
              <mat-icon>close</mat-icon>
            </button>

            <mat-autocomplete #autoDist1="matAutocomplete"
              (optionSelected)="onDeliveryModeChange1($event.option.value)">
              <mat-option *ngFor="let option of filteredOptions7 | async" [value]="option.name">
                {{ option.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>


          <mat-form-field style="margin-left: 40px; margin-top: 10px; width: 40%" appearance="outline">
            <mat-label>Sub Distribution Mode</mat-label>
            <input matInput formControlName="deliverySubModeId" [matAutocomplete]="autoSubMode1" />

            <mat-autocomplete #autoSubMode1="matAutocomplete">
              <mat-option *ngFor="let option of filteredOptions28 | async" [value]="option.name">
                {{ option.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <div class="form-row">
            <mat-form-field style="margin-left: 40px; margin-top: 10px; width: 40%" appearance="outline">
              <mat-label>Total Copies</mat-label>
              <input matInput formControlName="totalCopies" readonly />
            </mat-form-field>

          
            <mat-form-field style="margin-left: 40px; margin-top: 10px; width: 40%" appearance="outline">
              <mat-label>Total Amount</mat-label>
              <input matInput formControlName="totalAmount" readonly />
            </mat-form-field>
          </div>


          <div class="form-group">
            <button style="margin-left: 125px; width: 70%; margin-top: 10px" type="submit"
              [disabled]="publicationsaleForm.invalid" (click)="openchallanBill()" mat-raised-button color="primary">
              Add Issue Sele Challan
            </button>
          </div>
        </form>
      </mat-card>

      <mat-card class="card">
        <h2 style="text-align:center">List of Issue Seller Challan</h2>

        <div>
          <form [formGroup]="issueSellerbillFormsecond">
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Search Date</mat-label>
              <mat-date-range-input [rangePicker]="pickerrAi">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getChangedDateContractM11()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerrAi"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerrAi></mat-date-range-picker>

              <mat-error *ngIf="contractDetailsForm.controls.start.hasError(
                                  'matStartDateInvalid'
                                )
                              ">Invalid start date
              </mat-error>
              <mat-error *ngIf="contractDetailsForm.controls.end.hasError('matEndDateInvalid')
                              ">Invalid end date
              </mat-error>
            </mat-form-field>
          </form>
        </div>
        <div class="tableFixHead">
          <button [ngStyle]="{'display':allSelectedtable || someComplete() ? 'block' : 'none'}" style="float: right;"
            mat-raised-button class="btn btn-primary" (click)="printAdvtInvoice()">Print
            Invoices</button>
          <table class="table table-striped">
            <thead>
              <tr>
                <th>
                  <mat-checkbox class="example-margin" [checked]="allSelectedtable" color="primary"
                    [indeterminate]="someComplete()" (change)="setAll($event.checked)">
                  </mat-checkbox>
                </th>
                <th>Sr. No.</th>
                <th>Challan No.</th>
                <th>Challan Date</th>
                <th>Distribution Representative</th>
                <th>Action</th>


              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of advtInvoiceList; let i=index">
                <td>
                  <mat-checkbox [(ngModel)]="data.is_selected" color="primary" (ngModelChange)="updateAllComplete()">
                  </mat-checkbox>
                </td>
                <td>{{ i+1 }}</td>
                <td>{{ data['invoice_no'] }}</td>
                <td>{{ data['invoice_date'] }}</td>
                <td>{{ data['issue_seller_name'] }}</td>
               
                <td>
                  <button mat-icon-button matTooltip="View" class="btn-sm btn-outline-primary"
                    (click)="viewIssueSellerInvoice(data.id)"><mat-icon>visibility</mat-icon></button>

                  <button mat-icon-button matTooltip="Edit" class="btn-sm btn-outline-danger"
                    (click)="updateIssueSellerInvoice(data)"><mat-icon>edit</mat-icon></button>

                  <button mat-icon-button matTooltip="Cancel" class="btn-sm btn-outline-danger"
                    (click)="deleteIssueSellerInvoice(data.id)"><mat-icon>delete</mat-icon></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card>
    </mat-tab> -->

    <!-- <mat-tab label="Issue/Granth Sale Bill">
      <mat-card class="card">
        <form [formGroup]="publicationpaymententriesForm" (ngSubmit)="save_publicationpaymententries()">
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 40%" appearance="outline">
              
              <mat-label>Issue/granth : </mat-label>
              <mat-select (selectionChange)="getIssues($event)" required>
                <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
                  {{ item.category }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field style="margin-left: 20px; margin-top: 10px; width: 40%" appearance="outline">
              <mat-label>Issue Dates : </mat-label>
              <mat-select #mySel1 (selectionChange)="getAdvtDates($event)" multiple required>
                <mat-option value="all" (click)="toggleAllSelection1()">All</mat-option>
                <mat-option *ngFor="let item of getMagIssueDatesandNames"
                  value="{{ [item['issueDate'],item['issueName'],item['id']] }}">{{ item["issueDate"] | date:
                  "dd-MM-yyy" }}
                  {{ item["issueName"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field style="margin-top: 10px; margin-left: 7%; width: 60%" class="example-full-width"
              appearance="outline">
              <mat-label>Publication Month : </mat-label>
              <input matInput type="month" formControlName="monthdate" required />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 60%" appearance="outline">
              <mat-label>Issue Seller Name : </mat-label>
              <mat-select #isn (selectionChange)="getISN($event)" multiple required>
                <mat-option value="all" (click)="toggleAllSelectionISN()">All</mat-option>
                <mat-option *ngFor="let item of issueSellerName" value="{{ item['issueSellerName'] }}">
                  {{ item["issueSellerName"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 40%" class="example-full-width"
              appearance="outline">
              <mat-label>Bill No :</mat-label>
              <input type="text" formControlName="billno" matInput required readonly />
            </mat-form-field>
            <mat-form-field style="margin-left: 20px; margin-top: 10px; width: 40%" class="example-full-width"
              appearance="outline">
              <mat-label>Date</mat-label>
              <input matInput [matDatepicker]="picker9" formControlName="date" required />
              <mat-datepicker-toggle matSuffix [for]="picker9"></mat-datepicker-toggle>
              <mat-datepicker #picker9></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="form-group">
            <button style="margin-left: 125px; width: 70%; margin-top: 10px" type="submit"
              [disabled]="publicationpaymententriesForm.invalid" mat-raised-button color="primary">
              Add Issue/Granth Sale Bill
            </button>
          </div>
        </form>
      </mat-card>
    </mat-tab> -->
    <mat-tab>
      <ng-template mat-tab-label> 5<br>
        Pending Credit<br>Voucher
      </ng-template>
      <div class="row" [formGroup]="issueselForm" style="margin:15px 5px 5px 0px">
        <!-- First Row: 3 Fields -->
        <div class="row">
          <!-- Voucher Date Range (takes 4/12 of the row) -->
          <div class="col-md-4">
            <mat-form-field appearance="outline" style="width: 100%; margin-top: 16px;">
              <mat-label>Voucher Date (From…To)</mat-label>

              <mat-date-range-input [rangePicker]="pickerrel_2" [min]="financialYearMin" [max]="financialYearMax"
                [formGroup]="issueselForm">
                <input matStartDate formControlName="vstart_date" placeholder="Start date" />
                <input matEndDate formControlName="vend_date" placeholder="End date"
                  (dateChange)="userprofileDateRange1()" />
              </mat-date-range-input>

              <mat-datepicker-toggle matSuffix [for]="pickerrel_2"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerrel_2></mat-date-range-picker>

              <!-- Required errors -->
              <mat-error *ngIf="issueselForm.get('vstart_date')?.hasError('required')">
                Start date is required
              </mat-error>
              <mat-error *ngIf="issueselForm.get('vend_date')?.hasError('required')">
                End date is required
              </mat-error>

              <!-- Financial year error -->
              <mat-error *ngIf="issueselForm.hasError('financialYearInvalid')">
                Both dates must be within the current financial year
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Representative Name (takes 4/12 of the row) -->
          <div class="col-md-4">
            <mat-form-field appearance="outline" style="width: 100%; margin-top: 16px;">
              <mat-label>Representative Name</mat-label>
              <input matInput type="text" formControlName="rep_name" placeholder="Rep Name" />
            </mat-form-field>
          </div>

          <!-- Issue Seller Name (takes 4/12 of the row) -->
          <div class="col-md-4">
            <mat-form-field appearance="outline" style="width: 100%; margin-top: 16px;">
              <mat-label>Issue Seller Name</mat-label>
              <input matInput type="text" formControlName="advtName" placeholder="Issue Seller Name" />
            </mat-form-field>
          </div>
        </div>

        <button type="button" mat-raised-button color="primary" style="margin-left: 40%" (click)="searchbookselname()">
          Search
        </button>
      </div>

      <div class="add-new-subscriber mat-elevation-z4">
        <!-- Export Button (unchanged) -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 5%;" (click)="exportExcel('Pending_credit_vocuher')"
          mat-raised-button color="primary">
          Export
        </button>

        <!-- Print Button (unchanged) -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 5%;" mat-raised-button color="primary"
          printSectionId="print-section" [useExistingCss]="true" ngxPrint>
          Print
        </button>

        <!-- Wrap the table in a div with id="print-section" -->
        <div id="print-section" style="margin-top: 20px" class="tableFixHead">
          <!-- Give the table an id="excel-table" for exportExcel() -->
          <table id="excel-table" class="table table-striped text-center" style="padding: 30px;">
            <thead>
              <tr>
                <th>Action</th>
                <th>Sr.No.</th>
                <th>Voucher No.</th>
                <th>Voucher Date</th>
                <th>Rep.Name</th>
                <th>Issue Seller Name</th>
                <th>Tot Amount</th>
                <th>Rem Amount</th>
                <th>Cheque no</th>
                <th>Cheque date</th>
                <th>Branch Name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let book of getallVouchersData; let i = index">
                <td>
                  <button type="button" class="btn btn-danger btn-sm m-2" (click)="displayItemId(book)">
                    Mark as Completed
                  </button>
                </td>
                <td>{{ i + 1 }}</td>
                <td>{{ book["voucher_no"] }}</td>
                <td>{{ book["voucher_date"] }}</td>
                <td>{{ book["rep_name"] }}</td>
                <td>{{ book["advtName"] }}</td>
                <td>₹ {{ book["price"] }}</td>
                <td>₹ {{ book["remaining_amt"] }}</td>
                <td>{{ book["cheque_no"] }}</td>
                <td>{{ book["chequeDate"] | date: "dd-MM-yyyy" }}</td>
                <td>{{ book["branch_name"] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>6<br>
        Issue Seller<br>Payment Receipt
      </ng-template>
      <mat-card class="card">
        <div class="form-group" [formGroup]="advtpymtrecptform">

          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Credit Voucher No</mat-label>
              <input matInput type="text" formControlName="crdtvno" readonly />
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Date</mat-label>
              <input matInput type="date" formControlName="date" readonly />
            </mat-form-field>

          </div>

          <div class="form-row">
            <h3 style="padding-top: 10px;padding-right: 20px;margin-left: 5%">Select receipt is New/Delete</h3>
            <mat-button-toggle-group formControlName="newordeleted" (change)="newordel($event)" name="fontStyle"
              aria-label="Font Style" style="height: 50px;">
              <mat-button-toggle value="new">New</mat-button-toggle>
              <mat-button-toggle value="deleted">Deleted</mat-button-toggle>
            </mat-button-toggle-group>


            <!-- <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
            <mat-label>Receipt Date</mat-label>
            <input matInput type="date" formControlName="recptdate" readonly />
          </mat-form-field> -->
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 8%">
              <mat-label>Receipt Date</mat-label>
              <input matInput formControlName="recptdate" required />
              <!-- <mat-datepicker-toggle matSuffix [for]="pickerR1"></mat-datepicker-toggle>
            <mat-datepicker #pickerR1></mat-datepicker> -->
            </mat-form-field>

          </div>

          <div class="form-row ml-5">

            <mat-form-field appearance="outline" style="width: 28%;">
              <mat-label>Issue Seller Name</mat-label>
              <input matInput type="text" formControlName="advtname" readonly />
            </mat-form-field>

            <mat-form-field *ngIf="!deleterec" appearance="outline" style="width: 28%; margin-left: 3%">
              <mat-label>Receipt No</mat-label>
              <input matInput type="text" formControlName="recptno" readonly />
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 28%; margin-left: 3%">
              <mat-label>Representative Name</mat-label>
              <input matInput type="text" formControlName="repname" readonly />
            </mat-form-field>



            <!-- <mat-form-field *ngIf="deleterec" appearance="outline" style="width: 40%; margin-left: 5%">
            <mat-label>Receipt No (delete)</mat-label>
            <input matInput type="text" formControlName="recptno"  />
          </mat-form-field> -->
            <mat-form-field *ngIf="deleterec" appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt No (delete)</mat-label>
              <mat-select formControlName="recptno">
                <mat-option *ngFor="let receipt of getdeleterecipt" [value]="receipt.rcpt_no" readonly>
                  {{ receipt.rcpt_no }}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 27%; margin-left: 5%">
              <mat-label>Credit Voucher Amount</mat-label>
              <input matInput type="number" formControlName="crdtvamt" readonly />
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 27%; margin-left: 2%">
              <mat-label>Select Entry Amount</mat-label>
              <input matInput type="number" formControlName="seamt" readonly />
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 27%; margin-left: 2%">
              <mat-label>Balance Amount</mat-label>
              <input matInput type="number" formControlName="balamt" readonly />
            </mat-form-field>
          </div>

          <div class="form-row mt-5">
            <!-- <mat-form-field appearance="outline" style=" margin-left: 5%">
            <mat-label>Advt. Name</mat-label>
            <input matInput type="text" formControlName="advtname" readonly />
          </mat-form-field> -->
          </div>

          <mat-form-field class="example-full-width" appearance="outline" style="width: 40%; margin-left: 5%">
            <mat-label>Issue Seller Name Search</mat-label>
            <input matInput formControlName="advtnamesearch" (keyup)="getAdvtNames($event)" [matAutocomplete]="auto1" />
            <mat-autocomplete autoActiveFirstOption #auto1="matAutocomplete">
              <mat-option (onSelectionChange)="selected_name1($event, option)" *ngFor="let option of advt_names"
                [value]="option['issueSellerName']">
                {{ option["issueSellerName"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <!-- <mat-form-field class="example-full-width" appearance="outline" style="width: 25%; margin-right: 3%">
          <mat-label>Advertiser Name :</mat-label>
          <input matInput formControlName="advtnamesearch" (keyup)="getAdvtNames($event)" [matAutocomplete]="auto1" />
          <mat-autocomplete autoActiveFirstOption #auto1="matAutocomplete">
            <mat-option (onSelectionChange)="selected_name1($event, option)" *ngFor="let option of advt_names"
              [value]="option['name']">
              {{ option["name"] }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>    -->
          <!-- <button type="button" mat-raised-button color="primary" style="margin-left: 5%" > -->
          <button type="button" mat-raised-button color="primary" style="margin-left: 5%" (click)="searchAdvtName1()">
            Search
          </button>
        </div>

        <div style="margin-top: 20px; margin-left: 20px" class="tableFixHead1">
          <table class="table table-bordered table-hover text-center">
            <thead>
              <tr>
                <th>Invoice Date/Booking Date</th>
                <th>Invoice No</th>
                <th>Booking No</th>
                <th>Issue Seller Name</th>
                <th>Invoice Amt/Booking Amt</th>
                <th>Receive Amt</th>
                <th>Remaining Amount</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let book of getentrybyrepnamelist ">


                <td>{{ book.invoice_date | date: "dd-MM-yyy" }}</td>
                <td>{{ book["invoice_no"] }}</td>
                <td>{{ book["booking_no"] }}</td>
                <td>{{ book["issue_seller_name"] }}</td>
                <td>{{ book["pay_amt"] }}</td>
                <td>{{ book["rcv_amt"] || 0}}</td>
                <td>{{ book["pay_amt"]-book["rcv_amt"]}}</td>

                <!-- <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td> -->
                <td style="display: flex;">
                  <button [(disabled)]="this.click" type="button" mat-raised-button color="primary"
                    (click)="selectedItem(book)">
                    Select
                  </button>

                  <button style="margin-left: 2%" type="button" mat-raised-button class="btn btn-info"
                    (click)="updateIssueAnk(book)">
                    Update
                  </button>

                  <!-- <button mat-icon-button matTooltip="View" class="btn-sm btn-outline-primary"
                    (click)="viewAdvtInvoice(data.id)"><mat-icon>visibility</mat-icon></button>
                 
                  <button mat-icon-button matTooltip="Cancel" class="btn-sm btn-outline-danger"
                    (click)="cancelAdvtInvoice(data['id'])"><mat-icon>delete</mat-icon></button> -->

                </td>
              </tr>
            </tbody>
          </table>
        </div>


        <div class="form-group" style="display: flex; justify-content: center;">
          <button style="
        width: 60%;
        margin-top: 20px;" [disabled]="advtpymtrecptform.invalid" type="button" mat-raised-button color="primary"
            class="btn btn-primary btn-block" (click)="addadvtpymtrcpt()">
            Add
          </button>
        </div>
      </mat-card>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>7<br>
        Issue Seller<br>Payment Receipt Register
      </ng-template>
      
      <mat-card style="margin-top: 2%; padding: 10px;">
        <form [formGroup]="PaymentReceiptRegister">
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Receipt Date</mat-label>
              <mat-date-range-input [rangePicker]="pickerrPR" [min]="financialYearMin" [max]="financialYearMax">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getChangedDateContractM1()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerrPR"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerrPR></mat-date-range-picker>

              <mat-error *ngIf="
                              contractDetailsForm.controls.start.hasError(
                                'matStartDateInvalid'
                              )
                            ">Invalid start date
              </mat-error>
              <mat-error *ngIf="
                              contractDetailsForm.controls.end.hasError('matEndDateInvalid')
                            ">Invalid end date
              </mat-error>
            </mat-form-field>

            <mat-form-field style="margin-left: 3%; width: 35%;">
              <mat-label>Representative Name : </mat-label>
              <mat-select #mySel1 (selectionChange)="getContractRepName($event)" formControlName="rep_name" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of contractRepName" value="{{  item['name'] }}">{{ item["name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Office Representative : </mat-label>
              <mat-select #mySel1 (selectionChange)="getContractOffRepName($event)" formControlName="off_rep_name"
                multiple>
                <!-- <mat-option value="all" (click)="toggleAllSelection()">All</mat-option> -->
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of contractOffRepName" value="{{  item['name'] }}">{{
                  item["name"]
                  }}
                </mat-option>
              </mat-select>

            </mat-form-field>

            <mat-form-field style="margin-left: 3%; width: 35%">
              <mat-label>Issue/grantha : </mat-label>
              <mat-select (selectionChange)="getIssues($event)" formControlName="issuename" required>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>

                <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
                  {{ item.category }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field style="margin-left: 7%; width: 35%">
              <mat-label>Issue Dates : </mat-label>
              <mat-select (selectionChange)="getAdvtDates($event)" formControlName="issueDates" multiple required>
                <mat-option value="ALL">All</mat-option>
                <mat-option *ngFor="let item of getMagIssueDatesandNames"
                  value="{{ [item['issueDate']] | date : 'yyyy-MM-dd'}}">{{ item["issueDate"] | date :
                  "dd/MM/yyyy" }}
                  {{ item["issueName"] }}

                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Select type of report</mat-label>
              <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                <!-- <mat-option value="all" (click)="toggleAllSelection()">All</mat-option> -->
                <mat-option value="InDetail">In Detail
                </mat-option>
                <mat-option value="briefly1">Briefly
                </mat-option>
                <mat-option value="Monthwise">Monthwise
                </mat-option>
                <mat-option value="InDetail-Officer">InDetail-Officer
                </mat-option>
                <mat-option value="VeryBriefly-Officer">VeryBriefly-Officer
                </mat-option>
                <mat-option value="Briefly-Officer">Briefly-Officer
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- New Div For Issue Date Start-->

            <!-- <mat-form-field style="margin-left: 3%">
          <mat-label>Issue Dates : </mat-label>
          <mat-select (selectionChange)="getAdvtPaymentDates($event)" formControlName="issueDates" multiple required>
            <mat-option value="ALL">All</mat-option>
            <mat-option *ngFor="let item of getMagIssueDatesandNames" value="{{ item.id }}">{{ item["issueDate"] |
              date :
              "dd/MM/yyyy" }}
              {{ item["issueName"] }}

            </mat-option>
          </mat-select>
        </mat-form-field> -->

            <!-- End Issue Date Tab-->

            <div style="margin-left: 3%;">
              <button mat-raised-button type="button" class="
          btn btn-info" color="primary" (click)="showContractReportPRR()">Search</button>
            </div>
            <div style="margin-left: 3%;">
              <button mat-raised-button type="button" class="
          btn btn-info" color="primary" (click)="opentworeceipt()">Print</button>
            </div>

          </div>
        </form>
        <div class="tableFixHead">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>
                  <mat-checkbox class="example-margin" [checked]="allSelectedtable" color="primary"
                    (change)="selectall($event)">
                  </mat-checkbox>
                </th>
                <th>Receipt No</th>
                <th>Credit Voucher No</th>
                <th>Receipt Date</th>
                <th>Entry Date</th>
                <th>Issue Seller Name</th>
                <th>Rep. Name</th>
                <th>Off. Rep. Name</th>
                <th>Issue Name</th>
                <th>Issue Date</th>
                <th>Invoice Number</th>
                <th>Invoice Date</th>
                <th>Net Amount</th>
                <th>Received Amount</th>
                <th>Action</th>

              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of advtPaymentRegiInDetailsFormBeans">

                <tr>
                  <td>
                    <mat-checkbox [(ngModel)]="item.is_selected" color="primary" (change)="copydata1(item, $event)">
                    </mat-checkbox>
                  </td>
                  <td>{{ item['rcpt_no'] }}</td>
                  <td>{{ item['credit_voucher_no'] }}</td>
                  <td>{{ item['rcpt_date'] }}</td>
                  <td>{{ item['entry_date'] }}</td>
                  <td>{{ item['issue_seller_name'] }}</td>
                  <td>{{ item['rep_name'] }}</td>
                  <td>{{ item['off_rep_name'] }}</td>
                  <td>{{ item['DS_ISSUENAME'] }}</td>
                  <td>{{ item['DS_ISSUEDATE'] }}</td>
                  <td>{{ item["issue_invoice_no"] }}</td>
                  <td>{{ item["issue_invoice_date"] }}</td>
                  <td>{{ item['net_amt'] }}</td>
                  <td>{{ item['rcv_amt'] }}</td>
                  <td>
                    <button style="margin-left: 2%" type="button" mat-raised-button class="btn btn-info"
                      (click)="updateIssueAnk(item)">
                      Update
                    </button>

                    <button mat-icon-button class="btn-sm btn-outline-danger" matTooltip="Delete"
                      style="margin-left: 2%;"
                      (click)="deletePymtreceipt(item['id'])"><mat-icon>delete</mat-icon></button>
                  </td>

                </tr>
              </ng-container>

            </tbody>

          </table>
        </div>
      </mat-card>
    </mat-tab>


    <mat-tab>
      <ng-template mat-tab-label>8<br>
        Issue/Granth<br>Representative
      </ng-template>
      <mat-card style="margin-top: 20px">
        <table class="table table-striped table-fixed">
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>Representative Name</th>
              <th>Representative Mobile No</th>
              <th>Representative District</th>
              <th>Office Representative</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of issuewisereplist; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ item["rep_name"] }}</td>
              <td>{{ item["rep_mob_no"] }}</td>
              <td>{{ item["district"] }}</td>
              <td>{{ item["off_rep_name"] }}</td>
              <td>
                <button type="button" class="btn btn-info" color="primary" (click)="update(item)">
                  Update
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </mat-card>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>9<br>
        Issue Seller<br>Credit Note Receipt
      </ng-template>
      <mat-card class="card">
        <form class="form" [formGroup]="advtCreditNoteform">
          <div class="form-row">
            <mat-form-field style="width: 40%; margin-left: 5%" appearance="outline">
              <mat-label>Todays date</mat-label>
              <input style="height: 16px;" matInput type="date" formControlName="date" readonly />
            </mat-form-field>

            <!-- <mat-form-field class="example-full-width" style="width: 40%; margin-left: 5%;">
              <mat-label>Advertiser Name :</mat-label>
              <input #myInput matInput formControlName="advtname" (keyup)="getAdvtNames($event)"
                [matAutocomplete]="mc" required/>
              <mat-autocomplete #mc="matAutocomplete">
                <mat-option (selectionChange)="getContractOffRepName($event )"
                  *ngFor="let option of filteredOptions | async" [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field> -->
            <mat-form-field class="example-full-width" appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Issue Seller Name :</mat-label>
              <!-- formControlName="sadvtname" -->
              <input matInput formControlName="advtname" (keyup)="getAdvtNames($event)" [matAutocomplete]="auto1"
                required />
              <mat-autocomplete autoActiveFirstOption #auto1="matAutocomplete">
                <mat-option (onSelectionChange)="selected_name1($event, option)" *ngFor="let option of advt_names"
                  [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="form-row">


            <!-- <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt Date</mat-label>
              <input matInput type="date" (change)="GenerateCRno()" formControlName="recptdate"  />
            </mat-form-field> -->
            <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Credit Note Date</mat-label>
              <input matInput [matDatepicker]="startDatePicker07" [min]="financialYearMin" [max]="financialYearMax"
                (dateChange)="GenerateCRno()" formControlName="recptdate" required />
              <mat-datepicker-toggle matSuffix [for]="startDatePicker07"></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker07></mat-datepicker>
            </mat-form-field>


            <h3 style="padding-top: 10px;margin-left: 5%;padding-right: 20px;">Select receipt is New/Delete</h3>
            <mat-button-toggle-group formControlName="newordeleted" (change)="newordelcn($event)" name="fontStyle"
              aria-label="Font Style" style="height: 50px;">
              <mat-button-toggle value="new">New</mat-button-toggle>
              <mat-button-toggle value="deleted">Deleted</mat-button-toggle>
            </mat-button-toggle-group>


            <!-- <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Credit Note No</mat-label>
              <input matInput type="text" formControlName="crdtvno" required />
            </mat-form-field> -->


            <mat-form-field *ngIf="!deleterec" appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Credit Note No</mat-label>
              <input matInput type="text" formControlName="crdtvno" />
            </mat-form-field>
            <mat-form-field *ngIf="deleterec" appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Credit Note No(Deleted)</mat-label>
              <mat-select formControlName="crdtvno">
                <mat-option *ngFor="let cn of getdeleterecitcn" [value]="cn.rcpt_no">
                  {{ cn.rcpt_no }}
                </mat-option>
              </mat-select>
            </mat-form-field>



            <!-- <mat-form-field style="margin-left: 5%; width: 40%;">
              <mat-label>Representative Name : </mat-label>
              <mat-select #mySel1 multiple>
                <mat-option value="all" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of getdeleterecitcn" value="{{  item['rcpt_no'] }}">{{ item["rcpt_no"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
          </div>
          <div class="form-row">
            <!-- <mat-form-field style="margin-left: 5%; width: 40%;">
              <mat-label>Representative Name : </mat-label>
              <mat-select #mySel1 (selectionChange)="getContractRepName($event)" formControlName="creditRepName" multiple>
                <mat-option value="all" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of advtnewreplistForm" value="{{  item['rep_name'] }}">{{ item["rep_name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
            <!-- <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt No</mat-label>
              <input matInput type="text" formControlName="CrNno" readonly />
            </mat-form-field> -->

          </div>
          <div class="form-group">

            <button type="button" [disabled]="!advtCreditNoteform.value.recptdate" mat-raised-button color="primary"
              style="margin-left: 5%" (click)="addadvtCNrcpt()">
              Search
            </button>
          </div>
          <div style="margin-top: 20px; margin-left: 20px" class="tableFixHead1">
            <table class="table table-bordered table-hover text-center">
              <thead>
                <tr>
                  <th>Invoice Date</th>
                  <th>Invoice No</th>
                  <th>Rep Name</th>
                  <th>Issue seller Name</th>
                  <th>Invoice Amount</th>
                  <th>Amount Remaining</th>
                  <th>Copies</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let book of advtCreditNote">
                  <td>{{ book.invoice_date }}</td>
                  <td>{{ book["invoice_no"] }}</td>
                  <td>{{ book["rep_name"] }}</td>
                  <td>{{ book["issue_seller_name"] }}</td>
                  <td>{{ book["issue_amt"] }}</td>
                  <td>{{ book["remain_amt"] }}</td>
                  <td>{{ book["copies"] }}</td>


                  <td style="display: flex;">
                    <button [(disabled)]="this.click" type="button" mat-raised-button color="primary"
                      (click)="openAdvtBill1(book)">
                      Select
                    </button>
                    <!-- <button style="margin-left: 2%" type="button" mat-raised-button class="btn btn-info"
                      (click)="updateIssueAnk(book)">
                      Update
                    </button> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="form-group" style="display: flex; justify-content: center;">
            <button style="
                      width: 60%;
                      margin-top: 20px;
                    " type="button" mat-raised-button color="primary" class="btn btn-primary btn-block"
              (click)="openAdvtBill3()">
              Add
            </button>
          </div>
        </form>
      </mat-card>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>10<br>
        Issue Seller<br>Credit Note Register
      </ng-template>
      <mat-card style="padding: 30px 0px;">
        <form [formGroup]="CreditNoteForm">
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Enter Date</mat-label>
              <mat-date-range-input [rangePicker]="pickerrCN" [min]="financialYearMin" [max]="financialYearMax">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getChangedDateContractM2()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerrCN"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerrCN></mat-date-range-picker>

              <mat-error *ngIf="contractDetailsForm.controls.start.hasError('matStartDateInvalid')">Invalid start
                date</mat-error>
              <mat-error *ngIf="
                                  contractDetailsForm.controls.end.hasError('matEndDateInvalid')
                                ">Invalid end date
              </mat-error>
            </mat-form-field>

            <mat-form-field style="margin-left: 3%; width: 35%;">
              <mat-label>Representative Name : </mat-label>
              <mat-select #mySel1 (selectionChange)="getContractRepName($event)" formControlName="rep_name" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of contractRepName" value="{{  item['name'] }}">{{ item["name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Office Representative : </mat-label>
              <mat-select #mySel1 (selectionChange)="getContractOffRepName($event)" formControlName="off_rep_name"
                multiple>
                <!-- <mat-option value="all" (click)="toggleAllSelection()">All</mat-option> -->
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of contractOffRepName" value="{{  item['name'] }}">{{
                  item["name"]
                  }}
                </mat-option>
              </mat-select>

            </mat-form-field>

            <!-- <mat-form-field style="margin-left: 3%; width: 35%;">
              <mat-label>Issue Categary : </mat-label>
              <mat-select #mySel1 (selectionChange)="getContractAdvtName($event)" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let item of advtCategorylist" value="{{  item['category'] }}">{{ item["category"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
            <mat-form-field style="margin-left: 3%;width: 35%;">
              <mat-label>Issue/grantha : </mat-label>
              <mat-select (selectionChange)="getIssues($event)" formControlName="issuename" required>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>

                <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
                  {{ item.category }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field style="margin-left: 7%; width: 30%;">
              <mat-label>Issue Dates:</mat-label>
              <mat-select (selectionChange)="getAdvtDates($event)" formControlName="issueDates" multiple required>
                <!-- Select All option -->
                <mat-option [value]="'ALL'">All</mat-option>

                <!-- Individual issue dates -->
                <mat-option *ngFor="let item of getMagIssueDatesandNames" [value]="item.issueDate">
                  {{ item.issueDate | date: "dd/MM/yyyy" }} - {{ item.issueName }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field style="margin-left: 3%; width: 35%;">
              <mat-label>Select type of report</mat-label>
              <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                <!-- <mat-option value="all" (click)="toggleAllSelection()">All</mat-option> -->
                <mat-option value="InDetailCreditNote">In Detail
                </mat-option>
                <mat-option value="CreditNotebriefly">Briefly
                </mat-option>
                <mat-option value="CreditMonthwise">Monthwise
                </mat-option>
                <mat-option value="InDetail-CreditOfficer">InDetail-Officer
                </mat-option>
                <mat-option value="VeryBriefly-CreditNote">VeryBriefly-Officer
                </mat-option>
                <mat-option value="Briefly-OfficerCredit">Briefly-Officer
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div style="margin-left: 3%;">
              <!-- <button mat-raised-button type="button" class="
              btn btn-info" (click)="showContractReport121()">Search</button> -->


              <button mat-raised-button type="button" class="
              btn btn-info" color="primary" (click)="showContractReport122()">Search</button>

              <button mat-raised-button type="button" class="
              btn btn-info" color="primary" (click)="openBookCreditReceipt()">Print</button>
            </div>

          </div>
        </form>
        <div class="tableFixHead">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>
                  <mat-checkbox class="example-margin" [checked]="allSelectedtable" color="primary"
                    (change)="selectall($event)">
                  </mat-checkbox>
                </th>
                <th>Credit Note No</th>
                <th>CR Date</th>
                <th>Issue Seller Name</th>
                <th>Rep. Name</th>
                <th>Off. Rep. Name</th>
                <th>Issue Name</th>
                <th>Issue Date</th>
                <th>Invoice Number</th>
                <th>Invoice Date</th>
                <th>Net Amount</th>
                <th>Received Amount</th>
                <th>Remark</th>
                <th>Action</th>

              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of advtcreditnotetRegiInDetailsFormBeans">

                <tr>
                  <td>
                    <mat-checkbox [(ngModel)]="item.is_selected" color="primary" (change)="copydata2(item, $event)">
                    </mat-checkbox>
                  </td>
                  <td>{{ item['credit_voc_no'] }}</td>
                  <td>{{ item['voc_date'] }}</td>
                  <td>{{ item['issue_Seller_Name'] }}</td>
                  <td>{{ item['rep_name'] }}</td>
                  <td>{{ item['office_rep'] }}</td>
                  <td>{{ item['DS_ISSUENAME'] }}</td>
                  <td>{{ item['DS_ISSUEDATE'] }}</td>
                  <td>{{ item["issue_invoice_no"] }}</td>
                  <td>{{ item["issue_invoice_date"] }}</td>
                  <td>{{ item['net_amt'] }}</td>
                  <td>{{ item['credit_v_amt'] }}</td>
                  <td>{{ item['remark'] }}</td>
                  <td>
                    <!-- <button style="margin-left: 2%" type="button" mat-raised-button class="btn btn-info"
                      (click)="updateIssueAnk(item)">
                      Update
                    </button> -->

                    <button mat-icon-button class="btn-sm btn-outline-danger" matTooltip="Delete"
                      style="margin-left: 2%; vertical-align: middle; margin-top: -13px;"
                      (click)="deleteCreditNote(item['id'])">
                      <mat-icon>delete</mat-icon>
                    </button>


                  </td>

                </tr>
              </ng-container>

            </tbody>

          </table>
        </div>
      </mat-card>
    </mat-tab>


    <mat-tab>
       <ng-template mat-tab-label>11<br>
        Issue Seller<br> Personal Ledger
      </ng-template>
      <mat-card class="card">
        <form class="form" [formGroup]="PersonalNoteform">
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Enter Date</mat-label>
              <mat-date-range-input [rangePicker]="pickerpersonalledger" [min]="financialYearMin"
                [max]="financialYearMax">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getChangedDateContractM7()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerpersonalledger"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerpersonalledger></mat-date-range-picker>

              <mat-error *ngIf="
                                  contractDetailsForm.controls.start.hasError(
                                    'matStartDateInvalid'
                                  )
                                ">Invalid start date
              </mat-error>
              <mat-error *ngIf="
                                  contractDetailsForm.controls.end.hasError('matEndDateInvalid')
                                ">Invalid end date
              </mat-error>
            </mat-form-field>

            <mat-form-field class="example-full-width" style="width: 40%; margin-left: 5%;">
              <mat-label>Issue Seller Name :</mat-label>
              <input #myInput matInput formControlName="advtname" (keyup)="getAdvtNames($event)"
                [matAutocomplete]="advtNames" />
              <mat-autocomplete #advtNames="matAutocomplete">
                <mat-option (selectionChange)="getContractOffRepName($event )" *ngFor="let option of advt_names"
                  [value]="option['issueSellerName']">
                  {{ option["issueSellerName"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <!-- <mat-form-field class="example-full-width" style="width: 60%; margin-left: 5%; margin-top: 2%">
              <mat-label>Advertiser Name :</mat-label>
              <input #myInput matInput formControlName="sadvtname" (keyup)="getAdvtNames($event)"
                [matAutocomplete]="auto" />
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option (onSelectionChange)="selected_name1($event, option)"
                  *ngFor="let option of filteredOptions | async" [value]="option['name']">
                  {{ option["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field> -->

          </div>
          <div class="form-row">
            <!-- <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Credit Note No</mat-label>
              <input matInput type="text" formControlName="crdtvno"  />
            </mat-form-field> -->
            <!-- <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt Date</mat-label>
              <input matInput type="date" (change)="GenerateCRno()" formControlName="recptdate"  />
            </mat-form-field> -->
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Select type of report</mat-label>
              <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                <!-- <mat-option value="all" (click)="toggleAllSelection()">All</mat-option> -->
                <mat-option value="InDetail-personalledger">In Detail
                </mat-option>
                <mat-option value="briefly-personalledger">Briefly
                </mat-option>
              </mat-select>
            </mat-form-field>

            <button type="button" mat-raised-button color="primary" style="margin-left: 5%"
              (click)="showPersonalLedgerReport()">
              Search
            </button>
          </div>
          <div class="form-row">
            <!-- <mat-form-field style="margin-left: 5%; width: 40%;">
              <mat-label>Representative Name : </mat-label>
              <mat-select #mySel1 (selectionChange)="getContractRepName($event)" formControlName="creditRepName" multiple>
                <mat-option *ngFor="let item of advtnewreplistForm" value="{{  item['rep_name'] }}">{{ item["rep_name"]
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
            <!-- <mat-form-field appearance="outline" style="width: 40%; margin-left: 5%">
              <mat-label>Receipt No</mat-label>
              <input matInput type="text" formControlName="CrNno" readonly />
            </mat-form-field> -->

          </div>
          <div class="form-group">


          </div>

        </form>
      </mat-card>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>12<br>
        GST Ledger<br> 
      </ng-template>
      <mat-card style="margin-top: 2%;">
        <form [formGroup]="GSTFullReportForm" class="mt-5">
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Enter Date</mat-label>
              <mat-date-range-input [rangePicker]="pickergst" [min]="financialYearMin" [max]="financialYearMax">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getChangedDateContractM4()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickergst"></mat-datepicker-toggle>
              <mat-date-range-picker #pickergst></mat-date-range-picker>

              <mat-error *ngIf="
                                  contractDetailsForm.controls.start.hasError(
                                    'matStartDateInvalid'
                                  )
                                ">Invalid start date
              </mat-error>
              <mat-error *ngIf="
                                  contractDetailsForm.controls.end.hasError('matEndDateInvalid')
                                ">Invalid end date
              </mat-error>
            </mat-form-field>
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Select type of report</mat-label>
              <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                <mat-option value="GSTFullReport">GST Full Report
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>


          <div class="form-row">

            <!-- <div style="margin-left: 3%;">
              <button mat-raised-button type="button" class="
              btn btn-info" (click)="showContractReport()">Search</button>
            </div> -->
            <div style="display: flex; justify-content: center; margin-left: 45%;">
              <button mat-raised-button type="button" class="btn btn-info" color="primary"
                (click)="showContractReport()">Search</button>
            </div>

          </div>
        </form>
        <div class="tableFixHead">

        </div>
      </mat-card>
    </mat-tab>
    <!-- Issue Seller Outstanding Report  -->

    <mat-tab>

       <ng-template mat-tab-label>13<br>
        Issue Seller<br>Outstanding Reports
      </ng-template>
      <mat-card style="margin-top: 2%; margin-top: 2%;height: 400px;padding-top: 30px;">
        <h3 class="text-center" style="font-size: 25px; color: black; margin-bottom: 20px;">Issue Seller Outstanding
          Reports
        </h3>

        <form [formGroup]="OutStandingForm">
          <div class="form-row">
            <mat-form-field style="margin-left: 10%; width: 35%;">
              <mat-label>Enter Date</mat-label>
              <mat-date-range-input [rangePicker]="pickerOT" [min]="financialYearMin" [max]="financialYearMax">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getChangedDateContractM3()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerOT"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerOT></mat-date-range-picker>
              <mat-error *ngIf="
                                                contractDetailsForm.controls.start.hasError(
                                                  'matStartDateInvalid'
                                                )
                                              ">Invalid start date
              </mat-error>
              <mat-error *ngIf="
                                                contractDetailsForm.controls.end.hasError('matEndDateInvalid')
                                              ">Invalid end date
              </mat-error>
            </mat-form-field>

            <!-- <mat-form-field style="margin-left: 3%; width: 35%;">
                            <mat-label>Representative Name : </mat-label>
                            <input matInput formControlName="repname"/>
                            <mat-select #mySel1 (selectionChange)="getContractRepName($event)" multiple>
                              <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                              <mat-option *ngFor="let item of contractRepName" value="{{  item['name'] }}">{{ item["name"]
                                }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field> -->
            <!-- <mat-form-field style="margin-left: 3%; width: 35%;">
                            <mat-label>Representative Name : </mat-label>
                            <input formControlName="repname" matInput [matAutocomplete]="autorepnames"  (keyup)="getRepNames($event)"/>
                            <mat-autocomplete autoActiveFirstOption #autorepnames="matAutocomplete">
                              <mat-option (onSelectionChange)="getContractRepNames($event)"
                                *ngFor="let option of filterrep" [value]="option['rep_name']">
                                {{ option["rep_name"] }}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field> -->
            <mat-form-field style="margin-left: 3%; width: 35%;">
              <mat-label>Representative Name:</mat-label>
              <input #myInput matInput formControlName="repname" [matAutocomplete]="repname" />
              <mat-autocomplete #repname="matAutocomplete">
                <mat-option *ngFor="let option of offfilteroption3 | async"
                  (onSelectionChange)="selected_rep_name($event, option)"
                  [value]="option['issue_seller_representative']">
                  {{ option["issue_seller_representative"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field style="margin-left: 10%; width: 35%;">
              <mat-label>Office Representative:</mat-label>
              <input #myInput matInput formControlName="offrepname" [matAutocomplete]="offrepname" />
              <mat-autocomplete #offrepname="matAutocomplete">
                <mat-option *ngFor="let option of offfilteroption2 | async"
                  (onSelectionChange)="selected_off_rep_name($event, option)" [value]="option['office_representative']">
                  {{ option["office_representative"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field style="margin-left: 3%;width: 15%;">
              <mat-label>Issue/grantha : </mat-label>
              <mat-select (selectionChange)="getIssues($event)" formControlName="issuename" required>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>

                <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
                  {{ item.category }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field style="margin-left: 3%; width: 20%;">
              <mat-label>Issue Dates:</mat-label>
              <mat-select (selectionChange)="getAdvtDates($event)" formControlName="issueDates" multiple required>
                <!-- Select All option -->
                <mat-option [value]="'ALL'">All</mat-option>

                <!-- Individual issue dates -->
                <mat-option *ngFor="let item of getMagIssueDatesandNames" [value]="item.issueDate">
                  {{ item.issueDate | date: "dd/MM/yyyy" }} - {{ item.issueName }}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>
          <div class="form-row">
            <mat-form-field class="example-full-width" appearance="outline" style="margin-left: 10%; width: 35%;">
              <mat-label>Issue Seller Name :</mat-label>
              <!-- formControlName="sadvtname" -->
              <input matInput formControlName="advtname" (keyup)="getAdvtNames($event)" [matAutocomplete]="auto1" />
              <mat-autocomplete autoActiveFirstOption #auto1="matAutocomplete">
                <mat-option (onSelectionChange)="selected_name1($event, option)" *ngFor="let item of newadvtname"
                  value="{{  item['name'] }}">
                  {{ item["name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field style="margin-left: 3%; width: 35%;">
              <mat-label>Select type of report</mat-label>
              <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                <mat-option value="IssueoutstandingInDetails">All Outstanding In Detail
                </mat-option>
                <mat-option value="issueoutstandingbriefly">All Briefly
                </mat-option>
                <mat-option value="unpaidOutstandingInDetails">Unpaid OutStanding In Detail
                </mat-option>
                <mat-option value="unpaidOutstandingbriefly">Unpaid OutStanding Briefly
                </mat-option>
                <mat-option value="unpaidOutstandingVbriefly">Unpaid OutStanding Very Briefly
                </mat-option>
                <mat-option value="creditdOutstandingindetails">Credit OutStanding In Detail
                </mat-option>
                <mat-option value="creditOutstandingbriefly">Credit OutStanding Briefly
                </mat-option>
                <mat-option value="IssueSellerAddress">Issue Seller Address
                </mat-option>
                <mat-option value="AdvertisementAddressList">Issue Seller Address List
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-row">

            <div style="margin-left: 43%;margin-top: 15px;">
              <button mat-raised-button type="button" class="
                            btn btn-info" color="primary" (click)="showOutStandingReortReport()">Search</button>
            </div>
          </div>
        </form>
        <div class="tableFixHead">

        </div>
      </mat-card>

      <mat-card class="card">
        <h3 class="text-center" style="font-size: 25px; color: black; margin-bottom: 20px;">
          Send Reminder Letter
        </h3>

        <form class="form" [formGroup]="Sendreminderissueform">
          <div class="form-row">

            <!-- Date Field -->
            <mat-form-field appearance="outline" style="margin-left: 10%; width: 35%;">
              <mat-label>Enter Date</mat-label>

              <div class="date-inline">
                <input matInput type="date" formControlName="startDate" [min]="financialYearMin"
                  [max]="financialYearMax" />

                <span class="dash"> - </span>

                <input matInput type="date" formControlName="endDate" [min]="financialYearMin" [max]="financialYearMax"
                  (blur)="getChangedDateAdvtRemainder()" />
              </div>
            </mat-form-field>

            <!-- Report Type -->
            <mat-form-field style="margin-left: 3%; width: 35%;">
              <mat-label>Select type of report</mat-label>
              <mat-select #mySel1 (selectionChange)="getContractReportType($event)">
                <mat-option value="send-reminder1">To Issue Seller</mat-option>
                <mat-option value="send-reminder2">To Representative</mat-option>
              </mat-select>
            </mat-form-field>

          </div>

          <div class="form-row">

            <!-- Representative Name -->
            <mat-form-field style="margin-left: 10%; width: 35%;">
              <mat-label>Representative Name :</mat-label>
              <input matInput formControlName="repname" [matAutocomplete]="autorepnames3" (keyup)="getRepNames($event)"
                multiple />

              <mat-autocomplete autoActiveFirstOption #autorepnames3="matAutocomplete">
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>

                <mat-option *ngFor="let option of filterrep" [value]="option['rep_name']"
                  (onSelectionChange)="getContractRepNames($event)">
                  {{ option["rep_name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <!-- Advertiser Name – only when send-reminder1 -->
            <mat-form-field style="margin-left: 10%; width: 35%;" *ngIf="contractReportType=='send-reminder1'">
              <mat-label>Issue Seller Name :</mat-label>

              <mat-select #mySel1 (selectionChange)="getContractAdvtName($event)" formControlName="advtname" multiple>
                <mat-option *ngFor="let item of newadvtname" [value]="item['name']">
                  {{ item["name"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>

          <div class="form-row">
            <button type="button" mat-raised-button color="primary" style="margin-left: 5%;"
              (click)="showContractReportReminderissue()">
              Search
            </button>
          </div>

        </form>
      </mat-card>
    </mat-tab>

    <!-- Issue Seller Posting Label & Statement -->

    <mat-tab>
       <ng-template mat-tab-label>14<br>
        Issue Seller<br>Posting Label & Statement
      </ng-template>
      <form [formGroup]="generateform">

        <!-- ROW 1 -->
        <div class="form-row">
          <mat-form-field style="margin-left: 7%; margin-top: 20px; width: 25%" appearance="outline">
            <mat-label>Issue/grantha : </mat-label>
            <mat-select (selectionChange)="getIssues($event)" required formControlName="issueCatregoryId">
              <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
                {{ item.category }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field style="margin-left: 3%; margin-top: 20px; width: 25%" appearance="outline">
            <mat-label>Select Issue Date : </mat-label>
            <mat-select #mySel (selectionChange)="getIssueDate($event)" formControlName="issue_date" multiple required>
              <mat-option value="all" (click)="toggleAllSelection()">All</mat-option>
              <mat-option *ngFor="let item of getMagIssueDatesandNames"
                value="{{ [item['issueDate'], item['issueName'], item['id'],item['price']] }}">
                {{ item["issueDate"] | date: "dd-MM-yyy" }} {{ item["issueName"] }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field style="margin-left: 3%; margin-top: 20px; width: 25%" appearance="outline">
            <mat-label>Enter a date from...to </mat-label>
            <mat-date-range-input [rangePicker]="pickerbrr" [min]="financialYearMin" [max]="financialYearMax">
              <input matStartDate formControlName="start" placeholder="Start date" />
              <input matEndDate formControlName="end" placeholder="End date" (dateChange)="getBookReceiptDateRange()" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="pickerbrr"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerbrr></mat-date-range-picker>
            <mat-error *ngIf="generateform.controls.start.hasError('matStartDateInvalid')">Invalid start
              date</mat-error>
            <mat-error *ngIf="generateform.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
          </mat-form-field>
        </div>

        <!-- ROW 2 -->
        <div class="form-row">
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%">
            <mat-label>Issue Seller Name</mat-label>
            <mat-select [formControl]="showSelectedItems2" multiple>
              <input placeholder="Search Issue Seller Name here...!" [formControl]="searchControl2"
                style="width: 100%; padding: 30px; font-size: 16px; border: none; background-color: transparent;">
              <mat-option (click)="selectAllOptions($event)"> All </mat-option>
              <mat-option *ngFor="let option of filteredOptions2" [value]="option">
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>Country Name</mat-label>
            <mat-select #mySel3 formControlName="countryname"
              (selectionChange)="getCountry($event); getcountryname($event)" multiple>
              <mat-option *ngFor="let option of countries" [value]="option['country_name']">
                {{ option["country_name"] }}
              </mat-option>
            </mat-select>
            <button *ngIf="country_names" matSuffix mat-icon-button aria-label="Clear" (click)="reset_country_names()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>State Name</mat-label>
            <mat-select #mySelState formControlName="statename" (selectionChange)="getstatename($event)" multiple>
              <mat-option value="all" (click)="toggleAllSelectionState()">All</mat-option>
              <mat-option *ngFor="let option of states" [value]="option['state_name']">
                {{ option["state_name"] }}
              </mat-option>
            </mat-select>
            <button *ngIf="state_names" matSuffix mat-icon-button aria-label="Clear" (click)="reset_state_names()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <!-- ROW 3 -->
        <div class="form-row">
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%">
            <mat-label>District Name</mat-label>
            <mat-select #mySel5 formControlName="districtname"
              (selectionChange)="getDistricts($event); getdistrictname($event)" multiple>
              <mat-option value="all" (click)="toggleAllSelection5()">All</mat-option>
              <mat-option *ngFor="let option of cities" [value]="option['district_name']">
                {{ option["district_name"] }}
              </mat-option>
            </mat-select>
            <button *ngIf="district_names" matSuffix mat-icon-button aria-label="Clear"
              (click)="reset_district_names()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>Taluka Name</mat-label>
            <mat-select #mySel6 formControlName="talukaname" (selectionChange)="gettalukaname($event)" multiple>
              <mat-option value="ALL" (click)="toggleAllSelection6()">All</mat-option>
              <mat-option *ngFor="let option of talukas" [value]="option['taluka_name']">
                {{ option["taluka_name"] }}
              </mat-option>
            </mat-select>
            <button *ngIf="taluka_names" matSuffix mat-icon-button aria-label="Clear" (click)="reset_taluka_names()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>Pincode</mat-label>
            <mat-select #mySel7 formControlName="pincode" (selectionChange)="getpincode($event)" multiple>
              <mat-option *ngFor="let option of pindcodelist" [value]="option['pincode']">
                {{ option["pincode"] }}
              </mat-option>
            </mat-select>
            <button *ngIf="pincodes" matSuffix mat-icon-button aria-label="Clear" (click)="reset_pincodes()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <!-- ROW 4 -->
        <div class="form-row">
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%">
            <mat-label>Representative Name : </mat-label>
            <mat-select #mySel1 (selectionChange)="getContractRepName($event)" formControlName="rep_name" multiple>
              <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
              <mat-option *ngFor="let item of contractRepName" value="{{  item['name'] }}">
                {{ item["name"] }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>Office Representative : </mat-label>
            <mat-select #mySel1 (selectionChange)="getContractOffRepName($event)" formControlName="off_rep_name"
              multiple>
              <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
              <mat-option *ngFor="let item of contractOffRepName" value="{{  item['name'] }}">
                {{ item["name"] }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Delivery Mode -->
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>Delivery Mode</mat-label> <mat-select #mySel10 formControlName="deliveryModeId" multiple
              (selectionChange)="onDeliveryModeChange1($event.value)"> <!-- Select All option --> <mat-option
                value="all" (click)="toggleAllSelection7()"> All </mat-option> <!-- Individual delivery modes -->
              <mat-option *ngFor="let rep of delivery_mode" [value]="rep.delivery_mode"> {{ rep.delivery_mode }}
              </mat-option>
            </mat-select> <!-- Reset button --> <button *ngIf="selectedModes?.length" matSuffix mat-icon-button
              aria-label="Clear" (click)="resetDeliveryModes()"> <mat-icon>close</mat-icon> </button> </mat-form-field>


          <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%">
            <mat-label>Distribution Representative</mat-label>
            <input matInput formControlName="distributionRepresentativeId" [matAutocomplete]="autoDistr" />
            <mat-autocomplete autoActiveFirstOption #autoDistr="matAutocomplete">
              <mat-option (onSelectionChange)="distribution($event, option)"
                *ngFor="let option of filteredOptions6 | async" [value]="option['name']">
                {{ option["name"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>



          <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>Distribution Mode</mat-label>

            <mat-select #mySel15 formControlName="distributionMode" multiple
              (selectionChange)="onDeliveryModeChange3($event.value)">

              <!-- Select All option -->
              <mat-option value="all" (click)="toggleAllSelectiondpl($event)">All</mat-option>

              <!-- Individual options -->
              <mat-option *ngFor="let option of filteredOptions7 | async" [value]="option.name">
                {{ option.name }}
              </mat-option>
            </mat-select>

            <!-- Reset button -->
            <!-- <button *ngIf="selectedModes2?.length" matSuffix mat-icon-button aria-label="Clear"
              (click)="resetDistributionModeModes1()">
              <mat-icon>close</mat-icon>
            </button> -->
            <button *ngIf="generateform.get('distributionMode')?.value" matSuffix mat-icon-button
              (click)="resetDistributionModeModes1()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>


          <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>Sub Distribution Mode</mat-label>
            <mat-select #mySel16 formControlName="deliverySubModeId" multiple>

              <!-- Select All option -->
              <mat-option (click)="toggleAllSelectionspl($event)">All</mat-option>

              <!-- Individual options -->
              <mat-option *ngFor="let option of filteredOptions28 | async" [value]="option.name">
                {{ option.name }}
              </mat-option>
            </mat-select>

            <!-- Reset button -->
            <button *ngIf="selectedModes?.length" matSuffix mat-icon-button aria-label="Clear"
              (click)="resetsubDeliveryModes1()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

        </div>

        <!-- ROW 5 -->
        <div class="form-row">
          <mat-form-field appearance="outline" style="width: 25%; margin-left: 7%">
            <mat-label>Show Mobile No. in Labels</mat-label>
            <mat-select (selectionChange)="getmob_no($event)">
              <mat-option value="yes">Yes</mat-option>
              <mat-option value="no">No</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
            <mat-label>Show Customer No</mat-label>
            <mat-select (selectionChange)="getIsCustomer($event)">
              <mat-option value="yes">Yes</mat-option>
              <mat-option value="no">No</mat-option>
            </mat-select>
          </mat-form-field>


          <!-- <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
                <mat-label>Delivery Mode</mat-label>
                <mat-select #mySel13 required formControlName="deliveryModeId"
                  (selectionChange)="onDeliveryModeChange($event.value)">
                  <mat-option *ngFor="let rep of delivery_mode" value="{{ rep['delivery_mode'] }}">{{
                    rep["delivery_mode"]
                    }}
                  </mat-option>
                </mat-select>
              </mat-form-field> -->

          <div style="margin-left: 3%">
            <button *ngIf="!show_mob_no_hide" mat-raised-button color="primary"
              style="margin-left: 3%;padding-top: 31px;padding-bottom: 21px;"
              (click)="handleAddressLabelClick()">Districtwise
              Posting Address Label</button>
            <button *ngIf="show_mob_no_hide" mat-raised-button color="primary" style="margin-left: 3%;margin-top: 2%;"
              (click)="getAddressLabelswithMobileNo()">
              Districtwise Posting Address Label
            </button>
          </div>
          <div style="display: flex; align-items: center; gap: 1rem; margin-left: 7%;">
            <button *ngIf="!show_mob_no_hide" mat-raised-button matTooltip="search"
              class="btn btn-danger new-btn-danger" color="warn" (click)="postingLabelBriefReport()">
              Brief
            </button>

            <button *ngIf="show_mob_no_hide" mat-raised-button matTooltip="search" class="btn btn-danger new-btn-danger"
              (click)="getPostingLabelswithMobileNoReport()">
              Brief
            </button>

            <button mat-raised-button color="primary" (click)="openBarcodeDialog('ADD')">
              Go to Generate Barcodes
            </button>
            <button mat-raised-button color="primary" (click)="openBarcodeDialog('UPDATE')">
              Barcodes View
            </button>
          </div>

        </div>
      </form>

      <div style="text-align: center;font-size: 2rem; margin-top: 15px;font-weight: 500;">
          Reports
        </div>
      <mat-card class="mt-5 pb-5" [formGroup]="dispatchissueForm">
        

        <div class="form-row">
          <!-- Delivery Mode -->
          <mat-form-field appearance="outline" style="margin-left: 8%; width: 25%; margin-top: 20px">
            <mat-label>Delivery Mode</mat-label> <mat-select #mySel13 formControlName="deliveryModes" multiple
              (selectionChange)="onDeliveryModeChange1($event.value)"> <!-- Select All option --> <mat-option
                value="all" (click)="toggleAllSelectionpl()"> All </mat-option> <!-- Individual delivery modes -->
              <mat-option *ngFor="let rep of delivery_mode" [value]="rep.delivery_mode"> {{ rep.delivery_mode }}
              </mat-option>
            </mat-select> <!-- Reset button --> <button *ngIf="selectedModes?.length" matSuffix mat-icon-button
              aria-label="Clear" (click)="resetDeliveryModes1()"> <mat-icon>close</mat-icon> </button> </mat-form-field>

          <!-- Distribution Representative -->
          <mat-form-field appearance="outline" style="margin-left: 3%; width: 25%; margin-top: 20px">
            <mat-label>Distribution Representative</mat-label>
            <input matInput formControlName="distributionRepresentatives" [matAutocomplete]="autoDistpl" />
            <mat-autocomplete autoActiveFirstOption #autoDistpl="matAutocomplete">
              <mat-option (onSelectionChange)="distribution($event, option)"
                *ngFor="let option of filteredOptions6 | async" [value]="option['name']">
                {{ option["name"] }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <!-- Distribution Mode -->
          <mat-form-field appearance="outline" style="margin-left: 3%; width: 25%; margin-top: 20px">
            <mat-label>Distribution Mode</mat-label>

            <mat-select #mySel15 formControlName="distributionModes" multiple
              (selectionChange)="onDeliveryModeChange3($event.value)">

              <!-- Select All option -->
              <mat-option value="all" (click)="toggleAllSelectiondpl($event)">All</mat-option>

              <!-- Individual options -->
              <mat-option *ngFor="let option of filteredOptions7 | async" [value]="option.name">
                {{ option.name }}
              </mat-option>
            </mat-select>

            <!-- Reset button -->
            <!-- <button *ngIf="selectedModes2?.length" matSuffix mat-icon-button aria-label="Clear"
              (click)="resetDistributionModeModes1()">
              <mat-icon>close</mat-icon>
            </button> -->
            <button *ngIf="dispatchissueForm.get('distributionMode')?.value" matSuffix mat-icon-button
              (click)="resetDistributionModeModes1()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>


          <!-- Sub Distribution Mode -->
          <mat-form-field appearance="outline" style="margin-left: 8%; width: 25%; margin-top: 20px">
            <mat-label>Sub Distribution Mode</mat-label>
            <mat-select #mySel16 formControlName="deliverySubModes" multiple>

              <!-- Select All option -->
              <mat-option (click)="toggleAllSelectionspl($event)">All</mat-option>

              <!-- Individual options -->
              <mat-option *ngFor="let option of filteredOptions28 | async" [value]="option.name">
                {{ option.name }}
              </mat-option>
            </mat-select>

            <!-- Reset button -->
            <button *ngIf="selectedModes?.length" matSuffix mat-icon-button aria-label="Clear"
              (click)="resetsubDeliveryModes1()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <!-- Action Buttons -->
        <div class="form-row">
          <button mat-raised-button color="primary" style="margin-left: 8%; margin-top: 2%;"
            (click)="getDispatchlisteportStatement(true)">
            Dispatch Vitaran Report
          </button>
          <button mat-raised-button color="primary" style="margin-left: 2%; margin-top: 2%;"
            (click)="getofficelisteportStatement(true)">
            Office representative Report
          </button>
        </div>
      </mat-card>



      <mat-card class="mt-5 pb-5">
        <div style="text-align: center;font-size: 2rem; margin-top: 26px;font-weight: 500;">Post Statement</div>
        <div class="form-row">
          <mat-form-field appearance="outline" style="margin-left: 8%; width: 25%; margin-top: 20px">
            <mat-label>Select Dispatch Date</mat-label>
            <input matInput [matDatepicker]="pickerdispatch" (dateChange)="getDispatchDate($event)">
            <mat-datepicker-toggle matSuffix [for]="pickerdispatch"></mat-datepicker-toggle>
            <mat-datepicker #pickerdispatch></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="form-row">
          <button mat-raised-button color="primary" style="margin-left: 8%; margin-top: 2%;"
            (click)="getDistrictwiseStatement(true)">
            Districtwise Statement
          </button>
          <button mat-raised-button color="warn" style="margin-left: 2%; margin-top: 2%;"
            (click)="getDistrictwiseStatement(false)">
            View
          </button>

          <button mat-raised-button color="primary" style="margin-left: 3%; margin-top: 2%;"
            (click)="getStatewiseStatement(true)">
            Statewise Statement
          </button>
          <button mat-raised-button color="warn" style="margin-left: 2%; margin-top: 2%;"
            (click)="getStatewiseStatement(false)">
            View
          </button>

          <button mat-raised-button color="primary" style="margin-left: 2%; margin-top: 2%;"
            (click)="getPincodewiseStatement(true)">
            Pincodewise Statement
          </button>
          <button mat-raised-button color="warn" style="margin-left: 2%; margin-top: 2%;"
            (click)="getPincodewiseStatement(false)">
            View
          </button>

          <button mat-raised-button color="primary" style="margin-left: 8%; margin-top: 2%;"
            (click)="getOtherStatePincodewiseStatement(true)">
            Other State Pincodewise Statement
          </button>
          <button mat-raised-button color="warn" style="margin-left: 2%; margin-top: 2%;"
            (click)="getOtherStatePincodewiseStatement(false)">
            View
          </button>
        </div>


      </mat-card>


      <mat-card class="mt-5">
        <div style="text-align: center;
            font-size: 2rem;
            font-weight: 500;margin-bottom: 1rem;margin-top: 25px;padding: 20px;">Hand Delivery Statement</div>
        <form [formGroup]="distributionForm">
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 25%; margin-left: 8%">
              <mat-label>Distribution Representative</mat-label>
              <mat-select #mySel12 formControlName="disrep" (selectionChange)="getdistributionrep($event)" multiple>
                <mat-option value="ALL" (click)="toggleAllSelection()">All</mat-option>
                <mat-option *ngFor="let option of LabelsDispatchDisRepNames" [value]="option['dis_rep_name']">{{
                  option["dis_rep_name"]
                  }}</mat-option>
              </mat-select>
              <button *ngIf="disrepnames" matSuffix mat-icon-button aria-label="Clear"
                (click)="reset_distribution_rep_names()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
              <mat-label>Distribution Mode</mat-label>
              <mat-select #mySel13 formControlName="dismode" (selectionChange)="getdismode($event)">
                <mat-option *ngFor="let option of newdismode" [value]="option['dis_mode']">{{
                  option["dis_mode"]
                  }}</mat-option>
              </mat-select>
              <button *ngIf="dismode1" matSuffix mat-icon-button aria-label="Clear" (click)="reset_dismode()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
              <mat-label>Sub Distribution Mode</mat-label>
              <mat-select #mySel14 formControlName="subdismode" (selectionChange)="getsubdismode($event)">
                <mat-option *ngFor="let option of subdistmode" [value]="option['dis_sub_mode']">{{
                  option["dis_sub_mode"]
                  }}</mat-option>
              </mat-select>
              <button *ngIf="subdismode" matSuffix mat-icon-button aria-label="Clear" (click)="reset_subdismode()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 25%; margin-left: 8%">
              <mat-label>एका प्रतीचे वजन</mat-label>
              <input matInput type="number" formControlName="vajan">
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 25%; margin-left: 3%">
              <mat-label>टपाल दर</mat-label>
              <input matInput type="number" formControlName="tapalrate">
            </mat-form-field>
          </div>
        </form>
        <div class="form-row">
          <button mat-raised-button color="primary" style="margin-left: 8%;margin-bottom: 5%;"
            (click)="handDeliveryLabelList()">Dispatch
            Address</button>

          <button mat-raised-button color="primary" style="margin-left: 2%;margin-bottom: 5%;"
            (click)="handDeliveryLabel(true)">Parcel
            Label</button>
          <button mat-raised-button color="warn" class="btn btn-danger new-btn-danger"
            style="margin-left: 1%;margin-bottom: 5%;" (click)="handDeliveryLabel(false)">view</button>

          <button mat-raised-button color="primary" style="margin-bottom: 5%;" (click)="postStatement(true)">Dispatch
            Statement</button>
          <button mat-raised-button color="warn" class="btn btn-danger new-btn-danger"
            style="margin-left: 1%;margin-bottom: 5%;" (click)="postStatement(false)">view</button>

          <button mat-raised-button color="primary" style="margin-bottom: 5%;" (click)="handDelivery(true)">All
            Distributor Copies</button>
          <button mat-raised-button color="warn" class="btn btn-danger new-btn-danger"
            style="margin-left: 1%;margin-bottom: 5%;" (click)="handDelivery(false)">view</button>
        </div>
        <div class="form-row">

        </div>
        <!-- </div> -->
      </mat-card>



      <div class="form-row" style="
      display: flex;
      align-items: center;
      justify-content: center; /* Centers the heading text */
      position: relative;
      background-color: #8bbdbd;
      margin-bottom: 2%;
      margin-top: 2%;
        padding: 10px 20px;
      text-align: center;
        width: 100%;
        ">

        <h2 style="color: black; margin: 0;padding: 5px;">
          Print Order
        </h2>

        <!-- Font Awesome Arrow Icon -->


        <i class="fas fa-arrow-down" *ngIf="!showFields" style="
            font-size: 24px;
            color: black;
            position: absolute;
            right: 20px;" (click)="toggleFields()"></i>

        <i class="fas fa-arrow-up" *ngIf="showFields" style="
            font-size: 24px;
            color: black;
            position: absolute;
            right: 20px;" (click)="toggleFields()"></i>

      </div>

      <ng-container *ngIf="showFields" style="margin-left: 2%">
        <mat-card>
          <button mat-raised-button color="primary" style="margin-left: 2%;width: 150px;" (click)="printOrder()">Print
            Order</button>

          <div class="tableFixHead" style="margin-top: 2%;">
            <table class="table table-bordered ">
              <thead>
                <tr>
                  <th>आदेश क्र</th>
                  <th>आदेश दिनांक</th>
                  <th>अंक दिनांक...ते</th>
                  <th>एकूण प्रती</th>
                  <th>एकूण पृष्ठ</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of printOrderData">
                  <td>{{ item['order_id'] }}</td>
                  <td>{{ item['order_date'] }}</td>
                  <td>{{ item['issue_date_from'] | date:"dd-MM-yyyy" }} ते {{ item['issue_date_to'] | date:"dd-MM-yyyy"
                    }}
                  </td>
                  <td>{{ item['total_prati'] }}</td>
                  <td>{{ item['total_prustha'] }}</td>
                  <td><button mat-icon-button type="button" class="btn-sm btn-outline-primary" matTooltip="View"
                      (click)="viewPrintOrder(item)"><mat-icon>visibility</mat-icon></button>
                    <button mat-icon-button type="button" class="btn-sm btn-outline-info" matTooltip="Update"
                      (click)="updatePrintOrder(item)"><mat-icon>edit</mat-icon></button>
                    <!-- <button mat-icon-button class="btn-sm btn-outline-danger" matTooltip="Delete"
                      style="margin-left: 2%;"
                      (click)="cancelPrintOrder(item['order_id'])"><mat-icon>delete</mat-icon></button> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </mat-card>

        <mat-card class="p-3" style="margin-top: 10px;">
          <button mat-raised-button color="primary" style="margin-left: 2%;width:100px"
            (click)="printJavak()">जावक</button>

          <!-- <button mat-raised-button color="primary" style="margin-left: 2%;width:100px" (click)="printchallan()">challan</button> -->

        </mat-card>
        <mat-card class="p-3" style="margin-top: 10px;">
          <div class="row">
            <div class="col-md-4 col-12">
              <button mat-raised-button color="primary" style="margin-left: 2%;width:250px; height: 50px;"
                (click)="distSubReport()">Districtwise
                Subscription Report</button>
            </div>
            <!-- <div class="col-md-4 col-12">
              <button mat-raised-button color="primary" style="margin-left: 2%;width:250px; height: 50px;"
                (click)="distVSubReport()">Districtwise
                Varganidar
                Subscription Report</button>
            </div> -->
            <div class="col-md-4 col-12">
              <button mat-raised-button color="primary" style="margin-left: 2%;width:250px; height: 50px;"
                (click)="prantwiseReport()">Prantwise
                Report</button>
            </div>
          </div>
        </mat-card>
      </ng-container>




    </mat-tab>


    <mat-tab>
      <ng-template mat-tab-label>15<br>
        RNI REPORT<br>
      </ng-template>
      <mat-card style="margin-top: 2%;">
        <form [formGroup]="RNIFullReportForm" class="mt-5">
          <div class="form-row">
            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Enter Date</mat-label>
              <mat-date-range-input [rangePicker]="pickerGSTLedger">
                <input matStartDate formControlName="start" placeholder="Start date" />
                <input matEndDate formControlName="end" placeholder="End date"
                  (dateChange)="getChangedDateContractM5()" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerGSTLedger"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerGSTLedger></mat-date-range-picker>
            </mat-form-field>

            <mat-form-field style="margin-left: 7%; width: 35%;">
              <mat-label>Select type of report</mat-label>
              <mat-select (selectionChange)="getContractReportType($event)">
                <mat-option value="RNIFullReport">RNI REPORT</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-row" style="display: flex; justify-content: center; margin-left: 45%;">
            <button mat-raised-button type="button" class="btn btn-info" color="primary"
              (click)="showrniContractReport()">Search</button>
          </div>
        </form>
      </mat-card>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>16<br>
       Dengi Report<br>
      </ng-template>
      <mat-card class="expense">
        <form [formGroup]="expense">
          <h3 class="text-center" style="font-size: 25px;">DENGI REPORT</h3>
          <div class="form-row" style="margin-top: 10px;">
            <mat-form-field appearance="outline" style="margin-left: 2%; width: 15%">
              <mat-label>Start Date</mat-label>
              <input matInput type="date" formControlName="start" />
            </mat-form-field>

            <span class="date-separator" style="margin-left: 1%;margin-top: 15px;">-</span>

            <mat-form-field appearance="outline" style="margin-left: 1%;width: 15%">
              <mat-label>End Date</mat-label>
              <input matInput type="date" formControlName="end" (blur)="expenseledgerDateRange()" />
            </mat-form-field>
            <mat-form-field style="margin-left: 2%; width: 30%" class="example-full-width" appearance="outline">
              <mat-label>Select Main Expense</mat-label>
              <mat-select formControlName="expnameother" (selectionChange)="getSubExpByMainExp($event)">
                <mat-option *ngFor="let exp of mainExpData" [value]="{ id: exp['id'], source: exp['source'] }">
                  {{ exp["exp_name"] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field *ngIf="subexpense" style="margin-left: 2%; width: 30%" class="example-full-width"
              appearance="outline">
              <mat-label>Select Sub Expense</mat-label>
              <mat-select formControlName="subexpnameother" (selectionChange)="getSubExpName1($event)">
                <mat-option *ngFor="let exp of subExpData" value="{{ exp['sub_id'] }}">{{ exp["sub_exp_name"]
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <button style="margin-left: 30%; width: 30%;margin-top: 20px;margin-bottom: 20px;" type="button"
              [disabled]="expense.invalid" mat-raised-button color="primary" (click)="expense_report_new()">
              Get Report
            </button>
          </div>
        </form>
      </mat-card>

    </mat-tab>

  </mat-tab-group>
</div>